import {
    CONV_STORAGE,
    room,
    stopMediaPlayers,
    Video,
    convertPath,
    electronConfig,
    isElectron,
    // localRecording,
    // live_stream,
    permissions,
  } from "./roomnew.js"; //card 599
  import moment from "moment";
  import axios from "axios";
  import { EmojiButton } from "@joeattardi/emoji-button";
  import sanitizeHtml from "sanitize-html";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { BalloonEditor } from 'ckeditor5';
import {hideAll} from 'tippy.js';
import 'ckeditor5/ckeditor5.css';
import { editorConfig } from "../features/chat/editorConfig.js";
import {v4 as uuidv4 } from 'uuid'
import Main from "../features/chat-popup/Main.js";
import { initAddParticipantMenuEvent } from "../features/chat/addParticipantMenu.js";
import { debounceSearchChats, refreshDraftListPreviews, renderChatsList, setSelectedChatActive, updateChatBadge } from "../features/chat/chatsList.js";
import { addMembersFromMenu, createGroupChatFromMenu } from "../features/chat/functions.js";
import TeamsApi from "../features/integration/teams/TeamsApi.js";
import { readableStreamToBlob } from "../room/functions.js";
import Attachment from "../features/chat/Attachment.js";
import { ATTACHMENT_SPINNER_HTML, bindIncomingImageAttachmentLoading } from "../features/chat/attachmentLoading.js";
import { addPanelResizeEvents, setInitialChatLayoutDimensions } from "../features/chat/ResizablePanel.js";
import { formatBubbleTime } from "../features/chat/uiHelpers.js";
import {
    buildMessageBlockHtml,
    buildReplyPreview,
    computeGroupedAndSeen,
    getNextMessageMeta,
    getPreviousMessageMeta,
    maybeInsertDateSeparator,
} from "../features/chat/messageBuilder.js";
import {
    ChatComposerState,
    conversationKey,
    draftListPreview,
    groupConversation,
    pendingConversation,
} from "../features/chat/ChatComposerState.mjs";

  const BUTTON_DISABLE_DURATION = 2000;
  const TYPING_INDICATOR_TIMEOUT = 3000;
  const CHAT_MESSAGE_HIGHLIGHT_DURATION = 3000;
  const TYPING_DISPLAY_DURATION = 4000;
  const GUEST_PROPERTY_DELAY = 1500;

  var CryptoJS = require("crypto-js");

  const download = require("downloadjs");
  export default class Chat {
    constructor() {
      this.mainChat = new Main();
      this.composerState = new ChatComposerState();
      this.participantID = null;
      this.selectedParticipantsToMessage = []; // compatibility projection of activeConversation
      this.selectedChatId = null; // compatibility projection of activeConversation
      this.groups = [];
      this.messages = {};
      // card 451
      this.encryptedMessages = [{ recipients: [], messages: [] }];
      // end card 451
      this.leftChatParticipants = [];
      this.groupReads = [];
      this.myUniqueId = null;
      this.participantNames = [];
      this.previousNotificationCount = []; // storing previous notifications for groups
      this.previousNotificationCountPanel = []; // storing previous notifications for groups
      this.chatPanelStatus = "closed"; // opened | closed
      this.lastSelectedChatId = false;
      this.profileImgUser = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 13C6 13 3 18 3 18C3 18 6 22 12 22C18 22 21 18 21 18C21 18 18 13 12 13Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 6.44444C16.5 8.9 14.4855 10.8889 12 10.8889C9.5145 10.8889 7.5 8.9 7.5 6.44444C7.5 3.98889 9.5145 2 12 2C14.4847 2 16.5 3.98963 16.5 6.44444Z" fill="white"/></svg>`;
      
      // card 415
      this.sendMessageStatus = false; // if user can send message or not because the text field may be empty
      // end card 415

      //this.notificationSound = new Audio('/sounds/chat.mp3');
      // this.sounds=new KinoSound();
      this.groupNotifications = [];
      this.chatButtonNotifications = 0;
      this.toggleChatNotifications = 0;
      
      this.sendingMessageStatus = false;
      
      this.messageQueue = [];
      
      this.sanitizeNoOptions = {
        allowedTags: [],
        allowedAttributes: {
          span: [],
          img: [],
        },
        allowedSchemesByTag: {
          img: [],
        },
      };
      
      this.failedMessages = [{}];
      
      /**
       *      System Settings
      *
      */
     // we are trying to create a group in the database
     this.creatingGroupStatus = false;
     
     // setting up emojis
     // setting up emojis
     let emoji_button = document.querySelector("#view-emojis-btn");
     let emoji_picker = new EmojiButton({
       rootElement: document.querySelector("#conversationsScroller"),
       autoHide: false,
       emojiSize: "25px",
       showVariants: true,
       theme: "dark",
      });
      
      emoji_picker.on("emoji", (emoji) => {
        this.messageEditor.execute('insertEmoji', { emoji: emoji.emoji });
        // $("#message-text-field").append(
          //   `<span class="emoji-icon" contenteditable="false">${emoji.emoji}</span>`
          // );
          $(
            "#conversationsScroller .emoji-picker__wrapper .emoji-picker__search"
          ).focus();
          // card 415
          this.toggleChatSendMessageIcon();
          // card 415
        });
        emoji_button.addEventListener("click", (e) => {
        emoji_picker.pickerVisible
        ? emoji_picker.hidePicker()
        : emoji_picker.showPicker(emoji_button);
      });
      
      this.provider;
      
      this.messageAttachments = [];
      this.messageEditor=null;
      this.loadingMoreText=$("#loading-messages-text")
      this.hasMoreMessages=true;
      this.messagesPerPage=20;
      this.messagesListAtBottom = true;
      this.isMessageReply=null;
      
      this.setChatProvider();
      this.events();
    }
    
    
    setChatProvider() {
      if(permissions.isTeamsIntegrationEnabled()){
        this.provider = new TeamsApi();
      }
    }

    conversationForChatItem(chatItem) {
      if (chatItem?.group) return groupConversation(chatItem.group);
      if (chatItem?.pId) return pendingConversation([chatItem.pId]);
      return null;
    }

    isConversationSelected(chatItem) {
      const conversation = this.conversationForChatItem(chatItem);
      return conversation && conversationKey(conversation) === this.composerState.getActiveKey();
    }

    getConversationDraftPreview(chatItem) {
      const conversation = this.conversationForChatItem(chatItem);
      if (!conversation) return null;
      const draft = conversationKey(conversation) === this.composerState.getActiveKey()
        ? this.captureComposerDraft(false)
        : this.composerState.getDraft(conversation);
      return draftListPreview(draft);
    }

    captureComposerDraft(detachNodes = false) {
      const attachmentChildren = $('#attachment-container').children();
      const replyChildren = $('#reply-to-container').children();
      return {
        html: this.messageEditor?.getData() ?? '',
        attachments: [...this.messageAttachments],
        attachmentNodes: (detachNodes ? attachmentChildren.detach() : attachmentChildren).toArray(),
        reply: this.isMessageReply,
        replyNodes: (detachNodes ? replyChildren.detach() : replyChildren).toArray(),
      };
    }

    restoreComposerDraft(draft) {
      if (!this.messageEditor) return;
      this.messageAttachments = [...(draft.attachments ?? [])];
      this.isMessageReply = draft.reply ?? null;
      this.messageEditor.setData(draft.html ?? '');
      $('#attachment-container').empty().append(draft.attachmentNodes ?? []);
      const replyContainer = $('#reply-to-container').empty().append(draft.replyNodes ?? []);
      this.isMessageReply ? replyContainer.show() : replyContainer.hide();
      this.toggleChatSendMessageIcon();
    }

    activateComposerConversation(conversation) {
      if (!conversation) return;
      const nextKey = conversationKey(conversation);
      if (nextKey === this.composerState.getActiveKey()) return;
      const draft = this.composerState.select(conversation, this.captureComposerDraft(true));
      this.restoreComposerDraft(draft);
      refreshDraftListPreviews();
    }

    handleChatPanelClosed() {
      this.chatPanelStatus = 'closed';
      this.composerState.close(this.captureComposerDraft(false));
      refreshDraftListPreviews();
      const activeElement = document.activeElement;
      if (activeElement && document.getElementById('myConvoPanel')?.contains(activeElement)) {
        activeElement.blur();
      }
    }

    handleChatPanelOpened() {
      const publicGroupId = this.getPublicChat()?.id;
      const fallback = publicGroupId ? groupConversation(publicGroupId) : null;
      const opened = this.composerState.open(fallback);
      this.chatPanelStatus = 'opened';
      if (!opened.conversation) return;

      if (opened.conversation.type === 'group') {
        this.selectGroupChatById(opened.conversation.groupId);
      } else {
        this.selectedChatId = false;
        this.selectedParticipantsToMessage = [...opened.conversation.participantIds];
      }

      renderChatsList();
      this.restoreComposerDraft(opened.draft);
      this.scrollToBottom();
      $('#message-text-field').trigger('focus');
    }

    toggleChatSendMessageIcon() {
        const messageBody = this.messageEditor.getData();
        // console.log("Check send ",messageBody)
      if (
        this.messageAttachments.length ||
        messageBody.trim().length
      ) {
        $('#send-message-form .send-message button[type="submit"]').attr(
          "disabled",
          false
        );
        this.sendMessageStatus = true;
      } else {
        this.sendMessageStatus = false;
        $('#send-message-form .send-message button[type="submit"]').attr(
          "disabled",
          true
        );
      }
      refreshDraftListPreviews();
    }

    addAttachment(attachment) {
        this.messageAttachments.push(attachment);
        this.toggleChatSendMessageIcon();
    }

    removeAttachment(attachment) {
        this.messageAttachments = this.messageAttachments.filter((att) => att !== attachment);
        this.toggleChatSendMessageIcon();
    }

    async handleAttachmentSelectedFiles(files,inline=false){
        for (let i = 0; i < files.length; i++) {
            const attachment = new Attachment(files[i],inline);
            const src = await attachment.getSrc();
            let attachmentTag = null;
            const isImage = attachment.isImage();
            const isVideo = attachment.isVideo();
            if(isImage){
                const image = new Image();
                image.src = src;
                image.onload = () => {
                    image.width = image.width;
                    image.height = image.height;
                };
                image.id = attachment.id;
                image.alt = attachment.name;
                if(inline){
                    attachmentTag = $("<div />", {
                        class:"hosted-content-preview",
                        html: image,
                      });
                }else{
                    attachmentTag = $("<a />", {
                        class:"opacity-loading",
                        'data-src': src,
                        'data-fancybox': 'attachments',
                        html: image,
                      });
                }

            }else if(isVideo){
                const video = $("<video />", {
                    src: src,
                });
                attachmentTag = $("<a/>", {
                    class:"opacity-loading",
                    'data-src': src,
                    'data-fancybox': 'attachments',
                    'data-type': 'html5video',
                    html: video,
                  });
            }else{
                attachmentTag = $("<span />", {
                    class:"composer-file-preview opacity-loading",
                    html: [
                        $("<span />", {
                            class: "composer-file-icon",
                            html: `<i class="fas ${attachment.type === "application/pdf" ? "fa-file-pdf" : "fa-file"}" aria-hidden="true"></i>`,
                        }),
                        $("<span />", {
                            class: "composer-file-meta",
                            html: [
                                $("<span />", {
                                    class: "composer-file-name",
                                    text: attachment.name,
                                }),
                                $("<span />", {
                                    class: "composer-file-size",
                                    text: this.formatFileSize(attachment.size),
                                }),
                            ],
                        }),
                    ],
                });
            }
            let removeBtn = $("<span />", {
                class: "remove-icon",
                html: '<i class="fas fa-times"></i>',
              })

            if(!inline){
                removeBtn.on("click", (e) => {
                  e.stopPropagation();
                  $(e.currentTarget).closest("div.image-container").remove();
                  this.removeAttachment(attachment);
                });

                const loader = $("<div />", {
                    class: "upload-animation-loader loader--fixed",
                });

                const container = $("<div />", {
                    class: `image-container${!isImage && !isVideo ? " file-container" : ""}`,
                    html: [attachmentTag, removeBtn,loader],
                  })

                $("#attachment-container").append(
                    container
                );
                this.addAttachment(attachment);
                attachment.onUpload = () => {
                    loader.remove();
                    container.find(".opacity-loading").removeClass("opacity-loading");
                }
                attachment.startUpload();
            }else{
                 const container = $("<div />", {
                    class: "image-container",
                    html: [attachmentTag, removeBtn,"\n"],
                  })
                  removeBtn.on("click", (e) => {
                    e.stopPropagation();
                    container.remove();
                    this.removeAttachment(container);
                  });

                $("#message-text-field").append(container)
                this.placeCursorAtEnd(document.getElementById("message-text-field"));
                this.addAttachment(attachment);
            }

        }
    }

    placeCursorAtEnd(contentEditableElement) {
        // Create a range object
        const range = document.createRange();

        // Select the last child node inside the contenteditable element
        range.selectNodeContents(contentEditableElement);

        // Collapse the range to the end (placing the cursor at the end)
        range.collapse(false);

        // Get the current selection and remove any existing selections
        const selection = window.getSelection();
        selection.removeAllRanges();

        // Add the new range (with cursor at the end)
        selection.addRange(range);
      }


    async onAttachmentChoosen(e){
        const files = e.target.files;
        this.handleAttachmentSelectedFiles(files);
        // Process the files
        console.log("Selected files",files); // Example: log the files or perform actions with them

        // Clear the file input
        e.target.value = '';
    }

    bindAttachmentPaste() {
        const field = document.getElementById("message-text-field");
        if (!field) return;
        field.addEventListener("paste", (e) => {
            const items = (e.clipboardData || window.clipboardData)?.items;
            if (!items) return;
            const files = [];
            for (const item of items) {
                if (item.kind === "file") {
                    const file = item.getAsFile();
                    if (file) files.push(file);
                }
            }
            if (files.length) {
                e.preventDefault();
                e.stopPropagation();
                this.handleAttachmentSelectedFiles(files);
            }
        }, true);
        field.addEventListener("dragover", (e) => { e.preventDefault(); });
        field.addEventListener("drop", (e) => {
            const files = e.dataTransfer?.files;
            if (files && files.length) {
                e.preventDefault();
                this.handleAttachmentSelectedFiles(files);
            }
        });
    }

    getCurrentChatMentions(queryText) {
        const chat = this.groups.find(g=>g.id===this.selectedChatId);
        if(!chat || !this.provider) {return []}
        return this.provider.getChatMembers(chat,false).map(m=>({
            id: m.displayName,
            userId: m.user_id,
            email: m.email,
            name: m.displayName
        })).filter((p) => p.name.toLowerCase().search(queryText.toLowerCase()) > -1)
    }
    mentionCustomItemRenderer( item ) {
        console.log("Rendering item", item)
        const itemElement = document.createElement( 'span' );

        itemElement.classList.add( 'mention-list-item-custom' );
        itemElement.id = `mention-list-item-id-${ item.user_id }`;
        itemElement.textContent = `${ item.name } `;

        const usernameElement = document.createElement( 'span' );

        usernameElement.classList.add( 'mention-list-item-email' );
        usernameElement.textContent = item.email ?? '';

        itemElement.appendChild( usernameElement );

        return itemElement;
    }


    async events() {

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            // console.log("Observer entries",entry)
            if (entry.isIntersecting) {
                if(entry.target.id==="messages-top-observer"){
                    this.messageListTopReached();
                }else if(entry.target.id === "messages-bottom-observer"){
                    this.messageListBottomReached();
                }
            }else{
                if(entry.target.id === "messages-bottom-observer"){
                    this.messagesListAtBottom=false;
                }
            }
        });
    });
    const reachTopTarget = document.querySelector('#messages-top-observer');
    observer.observe(reachTopTarget);
    const reachBottomTarget = document.querySelector('#messages-bottom-observer');
    observer.observe(reachBottomTarget);
      // send message events
      setInitialChatLayoutDimensions();
      this.mainChat.initializeMessages();
      this.registerChatApi();

      BalloonEditor.create(document.querySelector('#message-text-field'), {...editorConfig(this.provider),
        mention:{
            feeds:[
                {
                    marker: '@',
                    feed: this.getCurrentChatMentions.bind(this),
                    itemRenderer: this.mentionCustomItemRenderer.bind(this)
                }
            ]
        }
      })
      .then((editor)=>{

            this.messageEditor = editor;
            editor.model.document.on('change:data', () => {
                // console.log('Editor content changed:', editor.getData());
                this.toggleChatSendMessageIcon();
            });

            editor.editing.view.document.on( 'enter', ( evt, data ) => {
                data.preventDefault();
                evt.stop();

                if(!data.isSoft) {
                    this.sendMessage(data);
                    return
                }
                editor.execute( 'shiftEnter' );
                editor.editing.view.scrollToTheSelection();
            }, { priority: 'high' } );

        console.log('Editor created');
      })
      .catch(err => { console.error('[Kino Error] [editorInit]', err); if (typeof Video !== 'undefined' && Video.showNotification) { Video.showNotification('<i class="fas fa-exclamation-triangle"></i>', 'Editor failed to load.', 'error'); } });

      addPanelResizeEvents();

      // attachments supported for native Kino chat and provider-backed chat
      const attachmentBtn = document.getElementById("attachment-btn");
      const filePicker = document.getElementById("atachment-file-picker");
      if (attachmentBtn && filePicker) {
          attachmentBtn.addEventListener("click", (e) => filePicker.click());
          filePicker.addEventListener("change", this.onAttachmentChoosen.bind(this));
      }
      // Single delegated bind covers every chat gallery (composer previews,
      // inline images, and message attachments) for current and future elements.
      Fancybox.bind(`[data-fancybox]`, this.fancyboxOptions());
      this.bindAttachmentPaste();


      $("#send-message-form").on("submit", (e) => this.sendMessage(e));

      $("#messages-list-container").on("click", ".reply-message-button", (e) => {
        const $message = $(e.currentTarget).closest(".message");
        const messageId = $message.attr("id")?.replace("message-", "");
        if (!messageId) return;
        const senderName = $message.find(".user-name").text();
        const bodyText = $message.find(".user-message .message-content").text() || "";
        this.startMessageReply({
          id: messageId,
          sender_name: senderName,
          message: $message.find(".user-message .message-content").html() || "",
        }, bodyText);
      });

      // add someone in the chat by clicking add new button
      $("#chat-list-add-participant-btn").on("click", (e) =>
        this.showParticpantsToChat()
      );

      // add someone to chat by Search
      $("#search-new-particpant").on("change paste keyup focus", (e) =>
        this.addSomeoneToChatBySearch(e)
      );
      $("#search-new-particpant").on("focusout", (e) => {
        this.selectGroupChatOnFocusOutTimeout = setTimeout(() => {
          if (!this.selectedParticipantsToMessage.length) {
            this.showPublicChat(e);
          } else {
            let group_id = this.getGroupId(
              this.selectedParticipantsToMessage.map((el) => el)
            );
            if (group_id) {
              this.selectGroupChatById(group_id);
            } else {
              this.clearChat();
              this.selectedChatId = false;
            }
          }
        }, 250);
      });

      // add someone to selectedParticipantsToMessage
      $("#add-chat-participant-list").on("click", "li a.participant-item", (e) =>
        this.addParticipantToSelectedParticipantsToMessage(e)
      );

      // Remove someone from selectedParticipantsToMessage
      $("#chat-content-container").on(
        "click",
        "ul.chat-list-participant-group li div.chat-list-participant-item",
        (e) => this.removeFromSelectedParticipantsToMessage(e)
      );

      $('#navClosePanel').on('click keydown', (event) => {
        if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        CONV_STORAGE.closePanel();
      });

      $(document).on('kino:chat-panel-closed', () => this.handleChatPanelClosed());
      $(document).on('kino:chat-panel-opened', () => this.handleChatPanelOpened());
      //begin code card 599
      // $("#chat-nav-tab").on("click", (e) => {
      //     if (!$(this).hasClass("active")) {
      //         stopMediaPlayers($("#conversations-tab"));
      //     }

      //     setTimeout(() => {
      //         this.scrollToBottom();
      //     }, 100);
      // });
      //end code card 599
      $("#download-messages").on("click", (e) => this.downloadMessages(e));

      /**
       *      Notifications Events
       */
      // Remove event notification for button  Chats on the bottom left of the page
      $("#view-chats-btn").on("click", (e) => {
        this.closeAddParticipantList();
        this.checkUsersWithoutMessages(e);
        //     this.previousNotificationCount = []
        //     this.chatButtonNotifications = 0;
        //     this.toggleChatNotifications = 0;
        //     let nootification_toggle_icon = $('#notification-count')
        //     nootification_toggle_icon.attr('data-value', 0)
        //     nootification_toggle_icon.html(0)

        //     let group_button_toggle_notification_icon = $('#total-notification-count')
        //     group_button_toggle_notification_icon.attr('data-value', 0)
        //     group_button_toggle_notification_icon.html(0)
        this.toggleChatList();
      });

      $("#messagging-section .emoji-picker__wrapper").on(
        "keypress keydown",
        "button.emoji-picker__emoji",
        (e) => {
          if (e.keyCode == 13 || e.which == 13) {
          }
        }
      );


      // // selecting group chat to talk to from the dropdown
      $("#chat-groups-list").on("click", "a", async (e) => {
        this.selectGroupChat(e);
      });

      $("#chat-message-container").on("click", ".retry-message", (e) => {
        e.stopPropagation();
        this.retrySendMessage(e);
      });

      initAddParticipantMenuEvent();
      $("#chats-search-input").on("input", (e) => {
        debounceSearchChats();
      });
    }

    isRecordingOrLiveStream() {
      // console.log(`Checking recording ${localRecording.isRecording},Live stream ${live_stream.streamingStatus}`);
      // if (
      //   localRecording.isRecording ||
      //   live_stream?.streamingStatus != "stopped"
      // ) {
      //   return true;
      // } else {
        return false;
      // }
    }
    nl2br(str) {
      return str.replace(/(?:\r\n|\r|\n)/g, "<br>");
    }
    tabToSpace(str) {
      return str.replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;");
    }
    spaceToNbsp(str) {
      return str.replace(/ /g, "&nbsp;");
    }
    toggleChatList() {
      if (
        $("#chat-content-container .chat-groups .chat-list-container").hasClass(
          "active"
        )
      ) {
        $(
          "#chat-content-container .chat-groups .chat-list-container"
        ).removeClass("active");
        return false;
      }
      $("#chat-content-container .chat-groups .chat-list-container").addClass(
        "active"
      );
      // card 18
      this.updateDropdownChatList();
      // end card 18
    }
    closeChatList() {
      $("#chat-content-container .chat-groups .chat-list-container").removeClass(
        "active"
      );
    }
    openChatList() {
      $("#chat-content-container .chat-groups .chat-list-container").addClass(
        "active"
      );
    }

    generateString(length = 256) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }
    addGroupNotification(group_id) {
      if (group_id == this.selectedChatId && this.chatPanelStatus == "opened") {
        this.scrollToBottom();
        return;
      }
      let group_index = false;
      this.groupNotifications.find((group, index) => {
        if (group.group_id == group_id) {
          group_index = index;
          return true;
        }
      });

      if (group_index === false) {
        // create group if doesnt exist
        this.groupNotifications.push({
          group_id: group_id,
          notifications: 0,
        });
        group_index = this.groupNotifications.length - 1;
      }
      if (!this.previousNotificationCount[group_id]) {
        this.previousNotificationCount[group_id] = 1;
      } else {
        this.previousNotificationCount[group_id] += 1;
      }
      if (!this.previousNotificationCountPanel[group_id]) {
        this.previousNotificationCountPanel[group_id] = 1;
      } else {
        this.previousNotificationCountPanel[group_id] += 1;
      }
      // initiate if it doesnt exist
      this.groupNotifications[group_index]["notifications"] += 1;

      let group_element = $("#chat-groups-list").find(
        `a.dropdown-item[data-group="${group_id}"] span.notification-icon`
      );
      group_element.attr(
        "data-value",
        this.groupNotifications[group_index]["notifications"]
      );
      group_element.html(this.groupNotifications[group_index]["notifications"]);
      updateChatBadge(group_id, this.groupNotifications.find((g) => g.group_id == group_id)?.notifications ?? 0);
      // adding notification count on group chat
      if (
        this.previousNotificationCountPanel[group_id] == 1
        // && this.chatPanelStatus == "closed"
      ) {
        this.toggleChatNotifications++;
        let toggle_notification_element = $("#notification-count");
        toggle_notification_element.attr(
          "data-value",
          this.toggleChatNotifications
        );
        toggle_notification_element.html(this.toggleChatNotifications);
      }
      if (this.previousNotificationCount[group_id] == 1) {
        this.chatButtonNotifications++;
        let total_notification_count_element = $("#total-notification-count");
        total_notification_count_element.attr(
          "data-value",
          this.chatButtonNotifications
        );
        total_notification_count_element.html(this.chatButtonNotifications);
      }

      //this.notificationSound.play()
      Video.sounds.play("newChatMessage");
    }
    readMessagesbyGroupId(group_id) {
      let group_index = false;
      this.groupNotifications.find((group, index) => {
        if (group.group_id == group_id) {
          group_index = index;
          return true;
        }
      });
      if (group_index === false) {
        // create group if doesnt exist
        this.groupNotifications.push({
          group_id: group_id,
          notifications: 0,
        });
        group_index = this.groupNotifications.length - 1;
      }

      if (
        this.groupNotifications[group_index] &&
        this.groupNotifications[group_index]["notifications"] &&
        this.chatButtonNotifications > 0
      ) {
        // this.chatButtonNotifications = this.chatButtonNotifications - this.groupNotifications[group_id].notifications;
        // this.toggleChatNotifications = this.toggleChatNotifications1ons;
        this.chatButtonNotifications = this.chatButtonNotifications - 1;

        if (this.toggleChatNotifications > 0) {
          // this.toggleChatNotifications = this.toggleChatNotifications = 0;
          this.toggleChatNotifications = this.chatButtonNotifications;
        }
        let total_notification_count_element = $("#total-notification-count");
        total_notification_count_element.attr(
          "data-value",
          this.chatButtonNotifications
        );
        total_notification_count_element.html(this.chatButtonNotifications);
        let toggle_notification_element = $("#notification-count");
        toggle_notification_element.attr(
          "data-value",
          this.toggleChatNotifications
        );
        toggle_notification_element.html(this.toggleChatNotifications);
      }
      this.groupNotifications[group_index]["notifications"] = 0;
      updateChatBadge(group_id, 0);
      this.previousNotificationCountPanel[group_id] = 0;
      this.previousNotificationCount[group_id] = 0;
      let group_element = $("#chat-groups-list").find(
        `a.dropdown-item[data-group="${group_id}"] span.notification-icon`
      );
      $(
        `.toolbar-bottom .chatBubbleContainer .chatBubbleMessageIcon[data-chat-id="${group_id}"] .chatBubbleNotificationNumber`
      ).empty();
      $(
        `.toolbar-bottom .chatBubbleContainer .chatBubbleMessageIcon[data-chat-id="${group_id}"] ~ .chatBubblesMessageContainer`
      ).removeClass("showChatMessageContainer");
      $(
        `.toolbar-bottom .chatBubbleContainer .chatBubbleMessageIcon[data-chat-id="${group_id}"]`
      )
        .closest(".videoViewContainer")
        .removeClass("message-req");
      setTimeout(() => {
        $(
          `.toolbar-bottom .chatBubbleContainer .chatBubbleMessageIcon[data-chat-id="${group_id}"]`
        )
          .closest(".videoViewContainer")
          .removeClass("message-shown");
      }, 500);
      group_element.attr("data-value", 0);
      group_element.html(0);
    }

    /***
     *
     *          DATABASE TRANSACTIONS
     *
     */

    async initChatPublicGroup() {
      this.creatingGroupStatus = true;
      await this.createGroup([], true)
        .then((res) => {
          this.createLocalGroup(res.data);
          const group_id = res.data.id;
          this.selectedChatId = group_id;
          this.lastSelectedChatId = this.selectedChatId;
        })
        .catch((err) => { console.error('[Kino Error] [chatGroupCreate]', err); if (typeof Video !== 'undefined' && Video.showNotification) { Video.showNotification('<i class="fas fa-exclamation-triangle"></i>', 'Failed to create chat group.', 'error'); } })
        .finally(() => {
          this.creatingGroupStatus = false;
          // clearInterval(checking_group_timeout)
        });
    }

    async loadGroupsAndMessages() {
      await axios
        .get(
          convertPath(
            `/chat/kino/${room.getName()}/groups?uniqueID=${this.myUniqueId}`
          ),
          await electronConfig()
        )
        .then(async (res) => {
          if (!res.data.length) {
            await this.initChatPublicGroup();
            return;
          }
          if (res.data) {
            await Promise.all(
              res.data.map(async (el) => {
                await this.createLocalGroup(el);
                if (this.getGroupChatById(el.id) != false) {
                  this.decryptGroupMessages(el.id, el.messages);
                }
              })
            );
          }
          // check if I am in the group
        })
        .catch((err) => {
          console.error("chat", err);
        });
      renderChatsList();
      this.selectedChatId = false;
    }

    async createGroup(participants = [], override = false) {
        if(this.provider && participants.length > 0){
            return this.provider.createNewChat(participants);
        }
      let pps = [];
      if (override) {
        pps = participants;
      } else {
        pps = this.selectedParticipantsToMessage.map((p) => {
          return {
            guest_id: p,
            displayName: this.getParticipantDisplayName(p),
          };
        });
      }

      //checking if it is not public chat
      if (pps.length && !pps.find((p) => p.guest_id == this.myUniqueId)) {
            pps.push({
            guest_id: this.myUniqueId,
            displayName: MY_NAME,
            });
      }
      let response = await axios.post(
        convertPath(`/chat/group`),
        {
          kino_id: room.getName(),
          participants: pps,
          read_by: [this.myUniqueId],
          is_public: pps.length ? false : true,
        },
        await electronConfig()
      );

      try {
        if (response.data.enc_key) {
          this.storeEncryptionKey(response.data.id, response.data.enc_key);
        }
      } catch (error) {
        console.error("chat_Error", error);
      }

      return response;
    }

    addGroupMembers(group_id,participants = []) {
        return new Promise(async (resolve, reject) => {
            axios.post(
                convertPath(`/chat/group/add-members`),
                {
                  kino_id: room.getName(),
                  participants: participants,
                  guest_id: this.myUniqueId,
                  group_id: group_id,
                },
                await electronConfig()
              ).then((res) => {
                resolve(res.data);
              }).catch((err) => {
                reject(err);
              });
        })
      }

    // card 120
    nameChanged(userId, displayName) {
      $(
        `#chat-groups-list a[data-participant="${this.getParticipantGuestId(
          userId
        )}"] .profile-img`
      ).html(
        this.getUserButton(sanitizeHtml(displayName, this.sanitizeNoOptions))
      );
      $(
        `#chat-groups-list a[data-participant="${this.getParticipantGuestId(
          userId
        )}"] .chat-name`
      ).text(sanitizeHtml(displayName, this.sanitizeNoOptions));
      $(
        `#add-chat-participant-list a[data-id="${this.getParticipantGuestId(
          userId
        )}"] .profile-img`
      ).html(
        this.getUserButton(sanitizeHtml(displayName, this.sanitizeNoOptions))
      );
      $(
        `#add-chat-participant-list a[data-id="${this.getParticipantGuestId(
          userId
        )}"] .profile-desc .full-name span`
      ).text(sanitizeHtml(displayName, this.sanitizeNoOptions));
      this.selectGroupChatById(this.selectedChatId);
    }
    // end card 120

    async sleep(time) {
      return await new Promise((r) => setTimeout(r, time));
    }

    async getDecryptedText(group_id, encrypted_text) {
      return await new Promise(async (resolve, reject) => {
        let dec_keys = localStorage.getItem("encs");
        if (dec_keys) {
          dec_keys = JSON.parse(dec_keys);
          let dec_key = dec_keys.find((enc) => group_id == enc.group);
          if (dec_key) dec_key = dec_key.enc;
          let decrypted_text = "";
          try {
            decrypted_text = CryptoJS.AES.decrypt(
              encrypted_text,
              dec_key
            ).toString(CryptoJS.enc.Utf8);
            if (decrypted_text == "") {
              decrypted_text = encrypted_text; //card 775
            }
          } catch (error) {
            decrypted_text = encrypted_text; //card 775
          }
          resolve(decrypted_text);
        } else {
          await this.sleep(2000);
          resolve(await this.getDecryptedText(group_id, encrypted_text));
        }
      });
    }

    decryptString(decryption_key, encrypted_text) {
      // Guard against non-string bodies (e.g. a message persisted/broadcast as an
      // object or array by another client). Rendering those directly produced
      // "[object Object]" in the bubble. Coerce to a usable string first.
      if (encrypted_text !== null && encrypted_text !== undefined && typeof encrypted_text !== "string") {
        if (typeof encrypted_text === "object") {
          encrypted_text = encrypted_text.message
            ?? encrypted_text.text
            ?? encrypted_text.body
            ?? "";
        }
        if (typeof encrypted_text !== "string") {
          encrypted_text = String(encrypted_text);
        }
      }
      // CryptoJS AES output is base64 that always begins with the "Salted__"
      // marker ("U2FsdGVk"). Use it to tell real ciphertext from legacy
      // plaintext so we never render encrypted gibberish to the user when the
      // key is missing/wrong (a wrong key makes the UTF-8 decode throw).
      const looksEncrypted =
        typeof encrypted_text === "string" &&
        encrypted_text.startsWith("U2FsdGVk");
      const unreadable =
        "<span class='italic-disabled'>Unable to load message</span>";
      try {
        if (!decryption_key) {
          return looksEncrypted ? unreadable : encrypted_text;
        }
        let decrypted_text = CryptoJS.AES.decrypt(
          encrypted_text,
          decryption_key
        ).toString(CryptoJS.enc.Utf8);
        if (decrypted_text === "") {
          return looksEncrypted ? unreadable : encrypted_text;
        }
        return decrypted_text;
      } catch (error) {
        return looksEncrypted ? unreadable : encrypted_text;
      }
    }

    encryptString(encryption_key, decrypted_text) {
      try {
        return decrypted_text.length > 0
          ? CryptoJS.AES.encrypt(decrypted_text, encryption_key).toString()
          : "";
      } catch (error) {
        return decrypted_text;
      }
    }

    storeGroupMessage(group_id, message) {
      if (this.messages[group_id]) {
        this.messages[group_id].push(message);
      } else {
        this.messages[group_id] = [message];
      }
      const group = this.groups.find(g=>g.id == group_id);
      group.lastMessageTime = moment(message.created_at);
      group.lastMessage = this.formatLastMessage(message.message, 80, message.attachments ?? [])

      console.log("Last updated group",group)
    }

    getDecryptionKey(groupId) {
      let encs = [];

      if (localStorage.getItem("encs")) {
        encs = JSON.parse(localStorage.getItem("encs"));
        if (encs && encs.length) {
          let group = encs.find((gr) => gr.group == groupId);
          if (group) {
            return group.enc;
          }
        }
      }
      return false;
    }

    updateLocalGroupMembers(group_id, members) {
        let group = this.getGroupChatById(group_id);
        if (group) {
            group.members = members;
        }
    }
    // Create a local group and add to HTML using group id
    async createLocalGroup(group, notify = false) {
      await axios
        .get(
          convertPath(
            `/chat/kino/${room.getName()}/participants?uniqueID=${
              this.myUniqueId
            }`
          ),
          await electronConfig()
        )
        .then((res) => {
          this.participantNames = res.data;
        })
        .catch((err) => { console.error('[Kino Error] [loadParticipantNames]', err); });

      // check if this message is meant for me or I sent it
      if (group.members.length) {
        if (
          !group.members.some(
            (pp) =>
              pp.guest_id == this.myUniqueId ||
              (USER_ID > 0 && pp.user_id == USER_ID)
          )
        )
          return;
      }
      let group_participants = group.members.filter(
        (pp) =>
          pp.guest_id != this.myUniqueId &&
          (USER_ID == 0 || pp.user_id != USER_ID)
      );

    //   pId: chat.id,
    //         group: chat.id,
    //         id: chat.id,
    //         name: this.getChatName(chat),
    //         members: this.getChatMembers(chat),
    //         isChat: true,
    //         isGroup: chat.chatType === "group",
    //         lastMessage: this.getChatLastMessage(chat),
    //         lastMessageTime: moment.utc(chat.lastMessagePreview?.createdDateTime),
    //         isOnline: status,
    //         unread: 0,
    //         isExternal: true

      this.groups.push({
        id: group.id,
        kino_id: group.kino_id,
        members: group.members,
        is_public: group.is_public,
        read_by: group.read_by,
        lastMessage: group.last_message,
        lastMessageTime: group?.last_message_time ? moment().utc(group.last_message_time) : null,
        created_at: group.created_at,
      });

      this.groupNotifications.push({
        group_id: group.id,
        notifications: 0,
      });

      renderChatsList();
      // let participants_list = this.getParticipantIds().filter(pId => {
      //     return (this.getParticipantDisplayName(pId).toLowerCase().search($('#search-new-particpant').val().toLowerCase()) > -1 )
      // })

      try {
        // card 120
        if (group_participants.length != 1) {
          $("#chat-groups-list").append(`<a class="dropdown-item" data-group="${
            group.id
          }" href="">

                          <div class="profile-img">
                              ${
                                group_participants.length
                                  ? this.getUserButton(
                                      sanitizeHtml(
                                        group_participants
                                          .map((el) => {
                                            return sanitizeHtml(
                                              this.getParticipantDisplayName(
                                                el.guest_id
                                              ),
                                              this.sanitizeNoOptions
                                            );
                                          })
                                          .join(", "),
                                        this.sanitizeNoOptions
                                      )
                                    )
                                  : this.getUserButton("Public Chat")
                              }
                          </div>
                          <div class="name-notifications">
                              <div class="chat-name">
                                  ${
                                    group_participants.length
                                      ? group_participants
                                          .map((el) => {
                                            return `${sanitizeHtml(
                                              this.getParticipantDisplayName(
                                                el.guest_id
                                              ),
                                              this.sanitizeNoOptions
                                            )}`;
                                          })
                                          .join(", ")
                                      : "Public Chat"
                                  }
                              </div>
                              <span class="notification-icon" data-value="0">0</span>
                          </div>
                  </a>`);
          // end card 120
        } else {
          // checking if group is already added in HTML
          if (
            $(
              `#chat-groups-list a[data-participant="${group_participants[0].guest_id}"]`
            ).length
          ) {
            $(
              `#chat-groups-list a[data-participant="${group_participants[0].guest_id}"]`
            ).attr("data-group", group.id);
          } else {
            $("#chat-groups-list").append(`<a class="dropdown-item" data-group="${
              group.id
            }" data-participant="${
              group_participants[0] ? group_participants[0].guest_id : ""
            }" href="">

                          <div class="profile-img">
                              ${this.getUserButton(
                                sanitizeHtml(
                                  this.getParticipantDisplayName(
                                    group_participants[0].guest_id
                                  ),
                                  this.sanitizeNoOptions
                                )
                              )}
                          </div>
                          <div class="name-notifications">
                              <div class="chat-name">${sanitizeHtml(
                                this.getParticipantDisplayName(
                                  group_participants[0].guest_id
                                ),
                                this.sanitizeNoOptions
                              )}</div>
                              <span class="notification-icon" data-value="0">0</span>
                          </div>
                      </a>`);
          }
        }
      } catch (error) {
        console.error("chat", error);
      }
    }

    getPublicChat() {
      return this.groups.find((group) => group.is_public);
    }
    // Finding groupId
    getGroupId(_participants) {
      _participants.push(this.myUniqueId);
      let groups = this.groups.filter((group) => {
        if (_participants.length == 1 && group.members.length == 0) return true; // geting public chat
        if (
          _participants.length == group.members.length &&
          group.members.every(
            (pp) =>
              _participants.includes(pp["guest_id"]) ||
              (USER_ID > 0 && pp["user_id"] == USER_ID)
          )
        )
          return true;
      });
      if (groups.length) return groups[0].id;
      return false;
    }

    getGroupChatById(group_id) {
      return this.groups.find((group) => group.id == group_id);
    }

    downloadMessageButton() {
      let messages = [];
      let hasMessages = false;
      if (this.selectedChatId) {
        messages = this.messages[this.selectedChatId];
        hasMessages = messages?.length > 0;
      }
      if (hasMessages) {
        $("#download-messages").attr("disabled", false);
        $("#download-messages").attr("title", "Download");
      } else {
        $("#download-messages").attr("disabled", true);
        $("#download-messages").attr("title", "No chat messages to download");
      }
    }

    getGroupName(group_participants) {
      if (group_participants.length) {
        return group_participants
          .filter(
            (pp) =>
              pp.guest_id != this.myUniqueId &&
              (USER_ID == 0 || pp.user_id != USER_ID)
          )
          .map((pp) => {
            return pp.displayName;
          })
          .join(", ");
      } else {
        return "Public";
      }
    }

    downloadMessages(e) {
      if (e) {
        e.stopPropagation();
      }
      let messages = [];
      let file_name = "";
      if (this.selectedChatId) {
        messages = this.messages[this.selectedChatId];
        let group_participants = [];
        if (messages?.length) {
          group_participants = this.groups.find(
            (group) => group.id == messages[0].group_id
          ).members;
          if (group_participants.length) {
            file_name = group_participants
              .filter(
                (pp) =>
                  pp.guest_id != this.myUniqueId &&
                  (USER_ID == 0 || pp.user_id != USER_ID)
              )
              .map((pp) => {
                return pp.displayName;
              })
              .join(" - ");
          } else {
            file_name = "Public Chat";
          }
        } else {
          file_name = "";
        }
        if (messages) {
          messages = messages.map((message) => {
            return `[${moment(message.created_at).format("M/D/yyyy h:mm A")}] ${
              message.sender == this.myUniqueId
                ? `${message.sender_name} (me): ${sanitizeHtml(
                    message.message,
                    this.sanitizeNoOptions
                  )}\r\n`
                : `${message.sender_name}: ${sanitizeHtml(
                    message.message,
                    this.sanitizeNoOptions
                  )}\r\n`
            }`;
          });
        }
      }
      if (!file_name.length) {
        return false;
      }
      // card 18
      $("#download-messages").attr("disabled", true);
      download(
        new Blob(messages, { type: "text/plain;charset=utf-8" }),
        file_name,
        "text/plain"
      );
      setTimeout(() => {
        $("#download-messages").attr("disabled", false);
      }, BUTTON_DISABLE_DURATION);
      // end card 18
      return false;
    }

    async init() {
      //uniqueid is GUEST_ID
      $("#myConvoPanel").removeClass("d-none")
      this.myUniqueId =
        typeof GUEST_ID != "undefined"
          ? GUEST_ID
          : room.getLocalParticipantProperty("guest_id"); //bb
      if (permissions.hasChat()) {
        axios
          .get(
            convertPath(`/chat/kino/${room.getName()}/participants`),
            await electronConfig()
          )
          .then((res) => {
            this.participantNames = res.data;
          })
          .catch((err) => { console.error('[Kino Error] [loadParticipantNames]', err); });

        this.participantNames.push({
          guest_id: this.myUniqueId,
          displayName: MY_NAME,
          user_id: USER_ID,
        });

        // this.loadAllUserNamesInChatList()
        if(!this.provider){
            this.loadGroupsAndMessages();
        }else{
            this.provider.init()
        }
        // Fancybox.bind("[data-fancybox]", {});
      }
    }

    getIntegration() {
        return "teams";
    }

    async getChatEncryptionKey(group_id) {
      try {
        //try to get the key from local storage if it's used before
        const localKey = this.getLocalEncKeyV2(group_id);
        if (localKey) return localKey;
        //use the chat group's own kino id when we know it, so the lookup always
        //matches the kino_id the group was stored under (falls back to the
        //active room name for brand-new groups not yet stored locally)
        const localGroup = this.getGroupChatById(group_id);
        const kinoId =
          localGroup && localGroup.kino_id ? localGroup.kino_id : room.getName();
        //try to get the key from the server
        const enc_key = await axios
          .get(
            convertPath(
              `/chat/keys/get/${kinoId}/${group_id}/${GUEST_ID}`
            ),
            await electronConfig()
          )
          .then((res) => {
            return res.data.key;
          })
          .catch((err) => null);
        console.log("chat_encryption_key", enc_key);
        //store the key in local storage
        if (enc_key) this.storeEncryptionKey(group_id, enc_key);

        //probably the chat has an old key, so we will get the old key from local storage
        if (!enc_key) {
          const oldKey = this.getDecryptionKey(group_id);
          return oldKey;
        }
        return enc_key;
      } catch (error) {
        console.error("chat_encryption_key", error);
        return null;
      }
    }

    storeEncryptionKey(group_id, enc_key) {
      let encs = [];
      if (localStorage.getItem("encs_v2"))
        encs = JSON.parse(localStorage.getItem("encs_v2"));
      if (!encs.find((gr) => gr.group_id == group_id)) {
        // group key doesn't exist in the local storage
        let new_encryption = {
          group_id: group_id,
          enc: enc_key,
          created_at: new Date().getTime(),
        };
        encs.push(new_encryption);
        // end sending the key to the other users;
        localStorage.setItem("encs_v2", JSON.stringify(encs));
        return true;
      }
      return false;
    }

    getLocalEncKeyV2(group_id) {
      let encs = [];

      if (localStorage.getItem("encs_v2")) {
        encs = JSON.parse(localStorage.getItem("encs_v2"));
        if (encs && encs.length) {
          let group = encs.find((gr) => gr.group_id == group_id);
          if (group) {
            return group.enc;
          }
        }
      }
      return false;
    }

    // card 451
    decryptCurrentMessages() {
      this.encryptedMessages.forEach(async (encrypted_message, index) => {
        let decryption_key = this.getDecryptionKey(encrypted_message.group_id);
        if (decryption_key) {
          let message = encrypted_message;

          let decrypted_text = await this.getDecryptedText(
            message.group_id,
            message.message
          )
            .then((res) => res)
            .catch((err) => err);
          message.message = decrypted_text ? decrypted_text : "";

          //begin card 755
          if (message.images) {
            message.images = await Promise.all(
              message.images.map(async (image) => {
                // return await axios.get(api.global.app_url+image).then(async (res) => {//uncomment on electron
                return await axios
                  .get(`${isElectron ? api.global.app_url + image : image}`)
                  .then(async (res) => {
                    //comment on electron
                    return await this.getDecryptedText(
                      message.group_id,
                      res.data
                    ).then((res) => res);
                  })
                  .catch((err) => err);
              })
            );
          } else {
            message.images = [];
          }
          //end card 755

          this.messages.push(message);
          delete this.encryptedMessages[index];
        }
      });
    }

    async decryptGroupMessages(group_id, encrypted_messages) {
      // let decryption_key = this.getDecryptionKey(
      //     encrypted_message.group_id
      // );
      const server_decryption_key = await this.getChatEncryptionKey(group_id);
      const decryption_key = server_decryption_key
        ? server_decryption_key
        : this.getDecryptionKey(group_id);
      for (let index = 0; index < encrypted_messages.length; index++) {
        // const encrypted_message = encrypted_messages[index];
        const message = encrypted_messages[index];
        if (decryption_key) {
          let decrypted_text = this.decryptString(
            decryption_key,
            message.message
          );
          message.message = decrypted_text ? decrypted_text : "";

          //begin card 755
          if (message.images) {
            message.images = await this.decryptImages(
              decryption_key,
              message.images
            );
          } else {
            message.images = [];
          }
          //end card 755
        }

        this.storeGroupMessage(group_id, message);
      }
    }

    async decryptImages(decryption_key, images) {
      return await Promise.all(
        images.map(async (image) => {
          // return await axios.get(api.global.app_url+image).then(async (res) => {//uncomment on electron
          return await axios
            .get(`${isElectron ? api.global.app_url + image : image}`)
            .then(async (res) => {
              //comment on electron
              return this.decryptString(decryption_key, res.data).then(
                (res) => res
              );
            })
            .catch((err) => err);
        })
      );
    }

    // end card 451

    guestIdPropertyChanged(user) {
      setTimeout(() => {
        // prevent adding dublicates
        this.addToParticipantDisplayNames(
          user.getProperty("guest_id"),
          user.getDisplayName(),
          user.getProperty("user_id")
        );
      }, GUEST_PROPERTY_DELAY);
    }

    // when a user connects on KINO
    userConnected(user) {
      // Do nothing
    }

    checkUsersWithoutMessages(e) {
      $("#chat-groups-list a[data-participant]:not(a[data-group])").each(
        (index, el) => {
          let participant_id = this.getParticipantParticipantId(
            $(el).data("participant")
          );

          /*Begin code card ID: 412 */
          if (!participant_id) el.remove();
          else if (
            Video.videos[participant_id] &&
            Video.videos[participant_id].disconnectTimer > 0
          )
            el.remove();
          /*End code card ID: 412 */
        }
      );
    }

    // GET PARTICIPANTS DOESNT INCLUDE HIMSELF
    getParticipantGuestId(participant_id) {
      return room.getParticipantById(participant_id)
        ? room.getParticipantById(participant_id).getProperty("guest_id")
        : null;
    }
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }
    getParticipantIds() {
      return [
        ...new Set(
          this.participantNames
            .filter(
              (user) =>
                user.guestId != this.myUniqueId &&
                (USER_ID == 0 || user?.user_id != USER_ID)
            )
            .map((user) => user.guestId)
        ),
      ];
    }

    participantHasChat(guest_id) {
      try {
        if (!permissions.isWorkspace) {
          return true;
        }
        const participant = room
          .getParticipants()
          .find((p) => p.getProperty("guest_id") == guest_id);
        if (participant && participant.getProperty("has_chat")) {
          return true;
        }
        return false;
      } catch (error) {
        return !permissions.isWorkspace;
      }
    }

    // True when an existing chat group already contains this participant, i.e.
    // there is real chat history with them. Used to keep removed-from-workspace
    // members visible only when a conversation already exists.
    participantHasChatHistory(guest_id) {
      try {
        return this.groups.some(
          (group) =>
            Array.isArray(group.members) &&
            group.members.some((m) => (m.guest_id ?? m) == guest_id)
        );
      } catch (error) {
        return false;
      }
    }

    /**
     *      Participant Display Names
     *
     */
    async addToParticipantDisplayNames(guest_id, displayName, user_id = 0) {
      // if (this.participantNames.some((pp) => pp)) return false;
      // await axios.get(convertPath(`/chat/kino/${room.getName()}/participants`), await electronConfig())
      // .then((res) => {
      //         this.participantNames = res.data;
      //     }).catch((err) => {});
      const exists = this.participantNames.find(
        (p) => p.guestId === guest_id && p.user_id == (user_id ?? 0)
      );
      if (!exists) {
        this.participantNames.push({
          guestId: guest_id,
          displayName: displayName,
          user_id: user_id,
          joined: "joined",
        });
      }
      // console.trace("participantNames", this.participantNames)
      renderChatsList();
    }

    getParticipantDisplayName(pId) {
      let pname = room
        .getParticipants()
        .find((p) => p.getProperty("guest_id") == pId)?._displayName;
      if (!pname) {
        // there is a mix in participant display names guestId with guest_id
        pname = this.participantNames
          .filter((pp) => pp.guestId == pId || pp.guest_id == pId)
          .map((pp) => pp.displayName);
        return pname.length ? pname[pname.length - 1] : "Kino Guest";
      }
      return pname;
    }
    getParticipantParticipantId(pId) {
      let participant = room
        .getParticipants()
        .find((p) => p.getProperty("guest_id") == pId);
      if (participant) {
        return participant.getId();
      }
      return false;
    }

    isParticipantOnline(pId) {
        const p = room
        .getParticipants()
        .find((p) => p.getProperty("guest_id") == pId);
        return p? true : false;
    }

    // Showing participants to chat on input name box and add new button
    showParticpantsToChat() {
      this.closeChatList();
      $("#add-chat-participant-list").empty();

      if (!this.getParticipantIds().length && this.groups.length == 1) {
        this.openAddParticipantList();
        $("#add-chat-participant-list").append(`
                  <li class="list-item">
                      <a class="participant-item empty"><span>There are no other users in this Kino.</span></a>
                  </li>
              `);
        return;
      }

      this.openAddParticipantList();
      let participants = this.getParticipantIds().filter((pId) => {
        return (
          this.getParticipantDisplayName(pId)
            .toLowerCase()
            .search($("#search-new-particpant").val().toLowerCase()) > -1
        );
      });
      // console.log("getParticipantIds", this.getParticipantIds())
      // console.log("participants", participants)

      // check is already added
      let left_participants = participants
        .filter((pId) => !this.selectedParticipantsToMessage.includes(pId))
        .map((pId) => {
          this.addParticpiantInGroupChatHTML(
            pId,
            this.getParticipantDisplayName(pId)
          );
          return pId;
        });

      if (!left_participants.length) {
        $("#add-chat-participant-list").append(`
                  <li class="list-item">
                      <a class="participant-item empty"><span>All participants have been added</span></a>
                  </li>
              `);
      }
    }

    groupUniqueParticipants() {
      const chatUsers = this.getChatsListArray();
      const participants = [
        ...new Set(
          this.participantNames.filter(
            (user) =>
              user.guestId != this.myUniqueId &&
              (USER_ID == 0 || user?.user_id != USER_ID)
          )
        ),
      ].filter((pp) => !chatUsers.find((pps) => pps.pId === (pp.guestId ?? pp.guest_id)));

      const nonSignedIn = participants.filter((pp) => pp.user_id == 0);
    //   console.log("nonSignedIn", nonSignedIn);
      const signedIn = participants.filter((pp) => pp.user_id > 0);
    //   console.log("signedIn", signedIn);
      const groupedUsers = signedIn.reduce((acc, cur) => {
        acc[cur.user_id] = cur;
        return acc;
      }, {});
    //   console.log("groupedUsers", groupedUsers);
      const uniqueParticipants = Object.values(groupedUsers).concat(nonSignedIn);
    //   console.log("uniqueParticipants", uniqueParticipants);
      return uniqueParticipants.map((pp) => pp.guestId ?? pp.guest_id);
    }

    // automatic searching while typing
    addSomeoneToChatBySearch(e) {
      // this.clearChat()
      this.hidePublicChat();
      // card 473
      this.closeAddParticipantList();
      //end card 473
      // this.selectedChatId = false;
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.openChatList();

      this.searchTimeout = setTimeout(() => {
        $("#chat-groups-list").empty();
        const participants = this.getChatsListArray();
        this.groupUniqueParticipants().forEach((el) => {
          participants.push({
            pId: el,
            group: null,
            name: this.getParticipantDisplayName(el),
            isChat: false,
          });
        });
        let found_items = participants.filter(
          (pp) =>
            pp.name
              .toLowerCase()
              .search($("#search-new-particpant").val().toLowerCase()) > -1
        );

        if (found_items.length) {
          found_items.forEach((found_item) => {
            this.appendChatToList(found_item);
          });
        } else {
          $("#chat-groups-list").append(`
                      <li class="list-item no-found">
                          <a class="participant-item"><span>No matches found</span></a>
                      </li>
                  `);
        }
      }, 150);
    }

    // card 18
    updateDropdownChatList() {
      this.openChatList();
      $("#chat-groups-list").empty();

      const participants = this.getChatsListArray();

      this.groupUniqueParticipants().forEach((el) => {
        participants.push({
          pId: el,
          group: null,
          name: this.getParticipantDisplayName(el),
          isChat: false,
        });
      });

      // perform search
      let found_items = participants.filter(
        (pp) =>
          pp.name
            .toLowerCase()
            .search($("#search-new-particpant").val().toLowerCase()) > -1
      );

      if (found_items.length) {
        found_items.forEach((found_item) => {
          this.appendChatToList(found_item);
        });
      } else {
        $("#chat-groups-list").append(`
                  <li class="list-item no-found">
                      <a class="participant-item"><span>No matches found</span></a>
                  </li>
              `);
      }
    }

    getChatLastMessage(group_id) {
        if (!this.messages[group_id]) {
            return null;
        }
        console.log("Group messages",this.messages[group_id])
        const lastMessage = this.messages[group_id][this.messages[group_id].length - 1];
        const lastMessageHtml = lastMessage?.message ?? '';
        return this.formatLastMessage(lastMessageHtml, 80, lastMessage?.attachments ?? [])
    }

    normalizeMessageBody(body) {
        if (body === null || body === undefined) {
            return '';
        }
        if (typeof body === 'string') {
            return body;
        }
        if (typeof body === 'object') {
            return body.message ?? body.text ?? body.body ?? body.content ?? '';
        }
        return String(body);
    }

    formatLastMessage(body,charlimit=80,attachments=[]) {
        body = this.normalizeMessageBody(body);
        if (!body && attachments?.length) {
            const hasImage = attachments.some((att) => att?.is_image || (att?.mime && att.mime.startsWith('image/')));
            return hasImage ? '📷 Image' : '📄 File';
        }
        const parser = new DOMParser();
        const doc = parser.parseFromString(body??'', 'text/html');

        if (doc.querySelector('a')) {
            return doc.body.innerText.replace("Sent via Kino Co-Working Space. Click to Enter",'').replace("Sent via Kino Workspace. Click to Enter",'').substring(0, charlimit);
        } else if (doc.querySelector('video')) {
            return '🎥 Video';
        } else if (doc.querySelector('img')) {
            return '📷 Image';
        } else if (doc.querySelector('p')) {
            return doc.querySelector('p').innerText.substring(0, charlimit);
        }else if (doc.querySelector('attachment')){
            return '📄 File';
        } else {
            return sanitizeHtml(body,this.sanitizeNoOptions).substring(0,charlimit) ?? "No messages";
        }
    }


    getChatsListArray() {
      console.log("groups", this.groups);
      if(this.provider){
        return this.provider.getLocalChats();
      }
      const participants = this.groups.map((group) => {
        const unread = this.groupNotifications.find((g) => g.group_id == group?.id)?.notifications ?? 0;
        if (!group.members.length)
          return {
            pId: null,
            group: group.id,
            name: "Public Chat",
            members: [],
            isChat: true,
            lastMessage: this.getChatLastMessage(group.id) ?? 'No messages',
            lastMessageTime: group.lastMessageTime,
            isOnline: false,
            unread: unread
          };

        if (group.members.length == 2) {
          let member = group.members.find(
            (pp) =>
              pp.guest_id != this.myUniqueId &&
              (USER_ID == 0 || pp.user_id != USER_ID)
          );
          if(!member){
            member = group.members.find(
                (pp) =>
                  pp.guest_id != this.myUniqueId
              );
          }

          if(member){
              return {
                pId: member?.guest_id,
                group: group.id,
                name: member.displayName,
                members: group.members,
                isChat: true,
                lastMessage: this.getChatLastMessage(group.id) ?? 'No messages',
                lastMessageTime: group.lastMessageTime,
                isOnline: this.isParticipantOnline(member?.guest_id),
                unread: unread
              };
          }
        }

        return {
          pId: null,
          group: group.id,
          name: group.members
            .filter(
              (participant) =>
                participant.guest_id != this.myUniqueId &&
                (USER_ID == 0 || participant.user_id != USER_ID)
            )
            .map((participant) => participant.displayName)
            .join(", "),
          members: group.members,
          isChat: true,
          lastMessage: this.getChatLastMessage(group.id) ?? 'No messages',
          lastMessageTime: group.lastMessageTime,
          isOnline: false,
          unread: unread
        };
      });

      return participants;
    }

    appendChatToList(found_item) {
      const notifications =
        this.groupNotifications.find((not) => not.group_id == found_item?.group)
          ?.notifications ?? 0;
      $("#chat-groups-list").append(`<a class="dropdown-item" ${
        found_item.pId ? `data-participant="${found_item.pId}"` : ""
      } ${found_item.group ? `data-group="${found_item.group}"` : ""}  href="">
              <div class="profile-img">
                  <div class="user-icon" title="" data-toggle="tooltip" data-placement="top" data-original-title="${sanitizeHtml(
                    found_item.name,
                    this.sanitizeNoOptions
                  )}">${this.profileImgUser}</div>
              </div>
              <div class="name-notifications">
                  <div class="chat-name">${sanitizeHtml(
                    found_item.name,
                    this.sanitizeNoOptions
                  )}</div>
                  ${
                    notifications > 0 || !found_item.isChat
                      ? `<span class="notification-icon" data-value="${notifications}">
                      ${notifications}
                  </span>`
                      : `
                      <span><i class='far fa-comments' style='font-size:16px;color:#6c757d'></i></span>
                  `
                  }
              </div>
          </a>`);
    }

    hidePublicChat() {
      if (
        !$(
          "#chat-content-container .chat-list-participant-group li.pub-chat"
        ).hasClass("d-none")
      ) {
        this.selectedChatId = false;
        this.clearChat();
        $(
          "#chat-content-container .chat-list-participant-group li.pub-chat"
        ).addClass("d-none");
      }
    }

    showPublicChat(e) {
      if (!this.selectedParticipantsToMessage.length) {
        let group_id = this.getGroupId([]);
        this.selectGroupChatById(group_id);
        $("#search-new-particpant").val("");
      }
    }

    // when we click a participant on the serch or button open
    addParticipantToSelectedParticipantsToMessage(e) {
      // this.selectedParticipantsToMessage.forEach(el => {
      // })

      e.preventDefault();
      let pId = $(e.currentTarget).data("id");
      if (!pId) return;
      $(e.currentTarget).parent().remove();

      // finding someone in chat list to bypass HTML issues in case user changes HTML
      this.selectedChatId = false;
      this.addToSelectedParticipantToMessageById(pId);
      this.downloadMessageButton();
      e.stopPropagation();
      this.showParticpantsToChat();
    }

    selectChatUsingParticipantId(participantId) {
      if (!room.getParticipantById(participantId)) return;
      let guest_id = room
        .getParticipantById(participantId)
        .getProperty("guest_id");
      this.clearChat();
      this.clearSelectedGroupChatHTML();
      this.selectedChatId = false;
      this.selectedParticipantsToMessage = [];
      this.addToSelectedParticipantToMessageById(guest_id);
    }

    addToSelectedParticipantToMessageById(pId) {
      pId = this.getParticipantIds().filter((pp) => pp == pId);
      if (!pId.length) return;

      this.selectedParticipantsToMessage.push(pId[0]);
      this.addToSelectedParticipantToMessageHTML(
        pId,
        this.getParticipantDisplayName(pId)
      );
      let group_id = this.getGroupId(
        this.selectedParticipantsToMessage.map((el) => el)
      );
      this.selectedParticipantsToMessage.forEach((el) => {});
      if (group_id) this.selectGroupChatById(group_id, false);
    }

    removeFromSelectedParticipantsToMessage(e) {
      e.stopPropagation(); // card 291
      let element = $(e.currentTarget).closest("li");
      let pId = element.data("id");
      if (!pId) return;
      this.selectedParticipantsToMessage =
        this.selectedParticipantsToMessage.filter(
          (pp) => pp != pId && pp != this.myUniqueId
        );
      element.remove();
      // card 120
      let userListLength = $(
        `.chat-list-participants .chat-list-participant-group li.d-none:not(.pub-chat)`
      ).length;
      if (userListLength > 0)
        $(
          `.chat-list-participants .chat-list-participant-group li.d-none:not(.pub-chat)`
        )
          .eq(userListLength - 1)
          .removeClass("d-none");
      // end card 120
      this.clearChat();

      let group_id = this.getGroupId(
        this.selectedParticipantsToMessage.map((el) => el)
      );
      if (group_id) this.selectGroupChatById(group_id, false);

      // card 359
      this.downloadMessageButton();
      // end card 359
    }

    /*************************
     *
     *      GROUP FUNCTIONS
     *
     */
    async sendMessage(e) {
      e.preventDefault();
      if (this.chatPanelStatus !== "opened") return false;
      const sendTarget = this.composerState.createSendTarget();
      if (!sendTarget) return false;
      let message_text = this.messageEditor.getData();
      // message_text = message_text.replace()
      if (!message_text.length && !this.messageAttachments.length)
        return;

      message_text = sanitizeHtml(message_text, {
        allowedTags: [
          "span", "br", "img", "p", "b", "strong", "i", "em", "u", "s", "del", "ins",
          "a", "code", "pre", "blockquote", "mark", "sub", "sup",
          "h1", "h2", "h3", "h4", "h5", "h6", "ul", "ol", "li", "at"
        ],
        allowedAttributes: {
          span: ["class", "style"],
          img: ["src", "id", "alt", "width", "height"],
          a: ["href", "target", "rel", "class"],
          at: ["id", "class", "data-mention"],
          p: ["class", "style"],
          h1: ["style"], h2: ["style"], h3: ["style"],
          h4: ["style"], h5: ["style"], h6: ["style"],
          mark: ["class", "style"],
          blockquote: ["class"],
          li: ["class"],
          code: ["class"],
        },
        allowedStyles: {
          "*": {
            "text-align": [/^(left|right|center|justify)$/],
            "color": [/^#(0x)?[0-9a-f]+$/i, /^rgb\(/i],
            "background-color": [/^#(0x)?[0-9a-f]+$/i, /^rgb\(/i],
          },
        },
        selfClosing: [ 'img', 'br', 'hr'],
        allowedSchemesByTag: {
          img: ["data"],
        },
        transformTags: {
          a: sanitizeHtml.simpleTransform("a", { target: "_blank", rel: "noopener noreferrer" }, true),
        },
      });
      console.log("Message text after sanitize", message_text);
    //   let message_images = images
    //     .map((index, el) => el.getAttribute("src"))
    //     .toArray();
      console.log("Message attachments", this.messageAttachments);
      const messageVideos = this.messageAttachments.find(a=>a.isVideo() && !a.isInline);
      const messageImages = this.messageAttachments.filter(a=>a.isImage() && !a.isInline);
      const messageAttachments = this.messageAttachments.filter(a=>(!a.isImage() && !a.isVideo()) || a.isInline);

      // check if message is all spaces and there is no pictures

      let space_message = message_text;
      space_message = space_message.replace(/\s/g, "");

      if (space_message?.length == 0 && this.messageAttachments.length == 0) {
        return false;
      }

      message_text = message_text.trim();

      this.messageEditor.setData("");
      $("#attachment-container").html("");
      // card 415
      this.toggleChatSendMessageIcon();
    // // create a group to chat with
    let group_id = sendTarget.groupId;
    this.composerState.clearDraft(sendTarget.key);
      if(this.provider){
          return this.handleExternalSendMessage({
            message: message_text,
            images: messageImages ?? [],
            videos: messageVideos ?? [],
            attachments: messageAttachments ?? [],
            group_id: group_id,
            replyTo: this.isMessageReply
          });
      }

      if (this.messageAttachments.length) {
          const files = this.messageAttachments.map((a) => a.file);
          this.messageAttachments = [];
          return this.sendNativeMessageWithAttachments(message_text, files, group_id, sendTarget);
      }

      const localMessageId = new Date().getTime() + "" + this.myUniqueId;
      const replyPreview = this.isMessageReply
        ? buildReplyPreview(this.isMessageReply, this.formatLastMessage.bind(this))
        : null;
      this.addMessageToHTML({
        id:localMessageId,
        user_id: this.myUniqueId,
        sender_user_id: USER_ID,
        sender_name: MY_NAME,
        message: message_text,
        images: [],
        date: new Date(),
        read_by: [this.myUniqueId],
        group_id: group_id,
        reply: replyPreview,
        isLastMine: true,
      });
      this.scrollToBottom();

      this.messageQueue.push({
        id: localMessageId,
        user_id: this.myUniqueId,
        sender_name: MY_NAME,
        sender_user_id: USER_ID,
        message: message_text,
        images: [],
        date: moment(),
        read_by: [this.myUniqueId],
        group_id: group_id,
        participant_ids: [...sendTarget.participantIds],
        conversation_key: sendTarget.key,
        reply: replyPreview,
      });
      this.clearMessageReply();

      if (this.sendingMessageStatus) return;
      this.sendingMessageStatus = true;
      this.performMessageSend();
    }

    async sendNativeMessageWithAttachments(message_text, files, group_id, sendTarget) {
        // Render the message immediately with local previews + an upload progress
        // pie, so the user sees their files in the chat while the upload runs.
        const localMessageId = new Date().getTime() + "" + this.myUniqueId;
        const objectUrls = [];
        const pending = files.map((file) => {
            const local_url = URL.createObjectURL(file);
            objectUrls.push(local_url);
            return {
                name: file.name,
                mime: file.type,
                size: file.size,
                is_image: (file.type || '').startsWith('image/'),
                local_url,
                pending: true,
            };
        });

        this.addMessageToHTML({
            id: localMessageId,
            user_id: this.myUniqueId,
            sender_user_id: USER_ID,
            sender_name: MY_NAME,
            message: message_text,
            images: [],
            attachments: pending,
            date: new Date(),
            read_by: [this.myUniqueId],
            group_id: group_id,
        });
        this.scrollToBottom();
        renderChatsList();
        this.clearMessageReply && this.clearMessageReply();

        if (!group_id) {
            try {
                const participants = sendTarget.participantIds.map((guest_id) => ({
                    guest_id,
                    displayName: this.getParticipantDisplayName(guest_id),
                }));
                const res = await this.createGroup(participants, true);
                await this.createLocalGroup(res.data);
                group_id = res.data.id;
                this.composerState.resolvePending(sendTarget, group_id);
                this.sendGroupIdChanged(group_id, sendTarget.key);
            } catch (err) {
                console.error("[Kino Error] [sendNativeMessageWithAttachments] create group", err);
                this.markAttachmentMessageFailed(localMessageId);
                objectUrls.forEach((u) => URL.revokeObjectURL(u));
                return;
            }
        }

        const encryption_key = await this.getChatEncryptionKey(group_id);
        let outgoing_message = message_text ?? "";
        if (encryption_key) {
            outgoing_message = this.encryptString(encryption_key, outgoing_message);
        }

        const formData = new FormData();
        formData.append("message", outgoing_message);
        formData.append("sender", this.myUniqueId);
        formData.append("sender_name", MY_NAME);
        formData.append("sender_user_id", USER_ID);
        files.forEach((file) => formData.append("attachments[]", file));

        try {
            const config = await electronConfig();
            const res = await axios.post(
                convertPath(`/chat/group/${group_id}/message`),
                formData,
                {
                    ...config,
                    headers: { ...(config?.headers || {}), "Content-Type": "multipart/form-data" },
                    onUploadProgress: (e) => {
                        if (!e.total) return;
                        const p = Math.round((e.loaded / e.total) * 100);
                        this.updateAttachmentUploadProgress(localMessageId, p);
                    },
                }
            );
            const saved = res.data;
            this.replaceMessageAttachments(localMessageId, saved.attachments ?? [], group_id);
            objectUrls.forEach((u) => URL.revokeObjectURL(u));
            renderChatsList();
            room.broadcastEndpointMessage({
                chat_message: "message_received_from_kino_user",
                content: {
                    ...saved,
                    message: outgoing_message,
                    images: [],
                    attachments: saved.attachments ?? [],
                },
                group: this.getGroupChatById(group_id),
            });
        } catch (err) {
            console.error("[Kino Error] [sendNativeMessageWithAttachments]", err);
            this.markAttachmentMessageFailed(localMessageId);
            objectUrls.forEach((u) => URL.revokeObjectURL(u));
        }
    }

    updateAttachmentUploadProgress(messageId, percent) {
        const el = document.getElementById(`message-${messageId}`);
        if (!el) return;
        el.querySelectorAll('.upload-pie').forEach((pie) => {
            pie.style.setProperty('--p', percent);
            pie.setAttribute('data-p', percent + '%');
        });
    }

    replaceMessageAttachments(messageId, attachments, group_id) {
        const el = document.getElementById(`message-${messageId}`);
        if (!el) return;
        const rendered = this.renderMessageAttachments(attachments, group_id);
        const existing = el.querySelector('.message-attachments');
        if (existing) {
            $(existing).replaceWith(rendered);
        } else if (rendered) {
            $(el).find('.user-message').first().prepend(rendered);
        }
    }

    markAttachmentMessageFailed(messageId) {
        const el = document.getElementById(`message-${messageId}`);
        if (!el) return;
        el.querySelectorAll('.upload-overlay').forEach((o) => o.remove());
        const um = el.querySelector('.user-message');
        if (um && !um.querySelector('.attachment-upload-error')) {
            const note = document.createElement('div');
            note.className = 'attachment-upload-error';
            note.innerHTML = '<i class="fas fa-exclamation-circle"></i> Upload failed.';
            um.appendChild(note);
        }
    }

    renderMessageAttachments(attachments, group_id, { remoteLoading = false } = {}) {
        if (!attachments || !attachments.length) return '';
        const wrapper = $("<div/>", { class: "message-attachments" });
        attachments.forEach((att) => {
            const isImage = att.is_image || (att.mime && att.mime.startsWith('image/'));
            if (att.pending) {
                const item = $("<div/>", {
                    class: `attachment-uploading ${isImage ? 'attachment-thumb' : 'attachment-file-chip'}`
                });
                if (isImage && att.local_url) {
                    item.append(`<img src="${att.local_url}" alt="${att.name || ''}">`);
                } else {
                    item.append(`<span class="file-icon"><i class="fas fa-file"></i></span>`
                        + `<span class="file-meta"><span class="file-name">${att.name || 'file'}</span>`
                        + `<span class="file-size">${this.formatFileSize(att.size)}</span></span>`);
                }
                item.append(`<span class="upload-overlay"><span class="upload-pie" style="--p:0" data-p="0%"></span></span>`);
                wrapper.append(item);
                return;
            }
            const rawUrl = att.url || att.path || '';
            const fullUrl = (isElectron && rawUrl && rawUrl.startsWith('/')) ? (api.global.app_url + rawUrl) : rawUrl;
            if (isImage) {
                const downloadUrl = fullUrl + (fullUrl.includes('?') ? '&' : '?') + 'download=1';
                if (remoteLoading) {
                    const link = $("<a/>", {
                        class: "attachment-thumb attachment-loading",
                        href: fullUrl,
                        'data-fancybox': group_id || 'attachments',
                        'data-type': 'image',
                        'data-download-src': downloadUrl,
                        'data-caption': att.name || '',
                        html: `<img src="${fullUrl}" alt="${att.name || ''}">${ATTACHMENT_SPINNER_HTML}`
                    });
                    wrapper.append(link);
                } else {
                    const link = $("<a/>", {
                        class: "attachment-thumb",
                        href: fullUrl,
                        'data-fancybox': group_id || 'attachments',
                        'data-type': 'image',
                        'data-download-src': downloadUrl,
                        'data-caption': att.name || '',
                        html: `<img loading="lazy" src="${fullUrl}" alt="${att.name || ''}">`
                    });
                    wrapper.append(link);
                }
            } else {
                const chip = $("<a/>", {
                    class: "attachment-file-chip",
                    href: fullUrl,
                    target: "_blank",
                    rel: "noopener",
                    download: att.name || '',
                    html: `<span class="file-icon"><i class="fas fa-file-download"></i></span>`
                        + `<span class="file-meta"><span class="file-name">${att.name || 'file'}</span>`
                        + `<span class="file-size">${this.formatFileSize(att.size)}</span></span>`
                });
                wrapper.append(chip);
            }
        });
        // Return an HTML string (not the jQuery object) so it can be safely
        // interpolated into buildMessageBlockHtml's template literal. Returning
        // the jQuery object coerces to "[object Object]" in the message body.
        return wrapper.prop('outerHTML');
    }

    formatFileSize(bytes) {
        if (bytes === null || bytes === undefined) return '';
        const units = ['B', 'KB', 'MB', 'GB'];
        let i = 0;
        let n = bytes;
        while (n >= 1024 && i < units.length - 1) { n /= 1024; i++; }
        return `${n.toFixed(n < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
    }

    fancyboxOptions() {
        // Fancybox v5 toolbar with an explicit Download button (+ zoom controls)
        return {
            Toolbar: {
                display: {
                    left: ["infobar"],
                    middle: ["zoomIn", "zoomOut"],
                    right: ["download", "thumbs", "close"],
                },
            },
        };
    }

    handleExternalSendMessage(message) {
        this.provider.sendMessage(message).then((kinoMessage) => {
            this.addMessageToHTML(kinoMessage);
            this.scrollToBottom();
            this.messageAttachments = [];
            renderChatsList();
            this.clearMessageReply();
        });
    }

    retrySendMessage(event) {
      let failed_element = $(event.currentTarget).closest(".user-message");
      let failed_id = failed_element.data("failed-id");
      if (this.failedMessages[failed_id]) {
        if (room.getConnectionState() != "connected") return false;

        this.messageQueue.push(this.failedMessages[failed_id]);
        this.failedMessages[failed_id].failedToSend = false;
        this.addMessageToHTML(this.failedMessages[failed_id]);

        this.scrollToBottom();

        this.failedMessages[failed_id] = {};
        $(event.currentTarget).closest(".message").remove();

        if (this.sendingMessageStatus) return;
        this.sendingMessageStatus = true;
        this.performMessageSend();
      }
    }

    async performMessageSend() {
      let element = this.messageQueue.shift();
      if (typeof element == "undefined") {
        this.sendingMessageStatus = false;
        this.mainChat.sendMessage({
          eventName: "sendingMessageStatus",
          status: false,
        });
        return;
      }

      let group_id = element.group_id || this.getGroupId([...(element.participant_ids ?? [])]);
      if (!group_id) {
        const participants = (element.participant_ids ?? []).map((guest_id) => ({
          guest_id,
          displayName: this.getParticipantDisplayName(guest_id),
        }));
        if (!participants.length) {
          element.failedToSend = true;
          this.failedMessages[element.id] = element;
          this.sendingMessageStatus = false;
          return;
        }
        try {
          const res = await this.createGroup(participants, true);
          await this.createLocalGroup(res.data);
          group_id = res.data.id;
          element.group_id = group_id;
          this.composerState.resolvePending({ key: element.conversation_key }, group_id);
          this.sendGroupIdChanged(group_id, element.conversation_key);
        } catch (err) {
          console.error("[Kino Error] [performMessageSend] create group", err);
          element.failedToSend = true;
          this.failedMessages[element.id] = element;
          this.sendingMessageStatus = false;
          return;
        }
      }
      const encryption_key = await this.getChatEncryptionKey(group_id);
      let unencrypted_text_message = element.message;
      let unencrypted_images = element.images;

      if (encryption_key) {
        element.message = this.encryptString(
          encryption_key,
          unencrypted_text_message
        );
        // console.log("Descrypted message", element.message);
        element.images = unencrypted_images.map((image) => {
          return this.encryptString(encryption_key, image);
        });
      }

      await axios
        .post(
          convertPath(`/chat/group/${group_id}/message`),
          {
            message: element.message,
            images: element.images,
            sender: this.myUniqueId,
            sender_name: element.sender_name,
            sender_user_id: element.sender_user_id,
          },
          await electronConfig()
        )
        .then((res) => {
          console.log("Res", res);
          res.data.images = unencrypted_images;
          res.data.message = unencrypted_text_message;
          if (element.reply) {
            res.data.reply = element.reply;
          }
          this.storeGroupMessage(group_id, res.data);
          room.broadcastEndpointMessage({
            chat_message: "message_received_from_kino_user",
            content: {
              ...res.data,
              message: element.message,
              images: element.images,
              reply: element.reply ?? null,
            },
            group: this.getGroupChatById(group_id),
          });
        })
        .catch((err) => { console.error('[Kino Error] [chatSend]', err); if (typeof Video !== 'undefined' && Video.showNotification) { Video.showNotification('<i class="fas fa-exclamation-triangle"></i>', 'Failed to send message.', 'error'); } });
      // setTimeout( () => this.performMessageSend(), 50);
      this.performMessageSend();
      this.downloadMessageButton();
      renderChatsList();
    }

    async retrieveMessage(message) {
      if (message.group.id == this.selectedChatId) {
        if (this.typingTimout) clearTimeout(this.typingTimout);
        $("#writing-message").html("");
      }

      // check if this message was meant for me
      if (message.group.members.length) {
        if (
          !message.group.members.some(
            (pp) =>
              pp.guest_id == this.myUniqueId ||
              (pp.user_id == USER_ID && USER_ID > 0)
          )
        )
          return;
      }
      const decryption_key = await this.getChatEncryptionKey(message.group.id);
      // finding decryption key
      let decrypted_text = this.decryptString(
        decryption_key,
        message.content.message
      );

      message.content.message = decrypted_text ? decrypted_text : "";

      if (message.content.images && message.content.images.length) {
        message.content.images = await this.decryptImages(
          decryption_key,
          message.content.images
        );
      } else {
        message.content.images = [];
      }

      message.content.attachments = message.content.attachments ?? [];

      if (!this.getGroupChatById(message.group.id)) {
          await this.createLocalGroup(message.group, true);
        }

      this.storeGroupMessage(message.group.id, message.content);

      this.mainChat.sendMessage({
        eventName: "chatMessageReceived",
        ...message,
      });
      if (message.group.id == this.selectedChatId && this.chatPanelStatus === "opened") {
        updateChatBadge(message.group.id,0);
        this.addMessageToHTML({
          id: message.content.id,
          user_id: message.content.sender,
          sender_name: message.content?.sender_name,
          sender_user_id: message.content?.sender_user_id,
          message: message.content.message,
          images: message.content.images,
          attachments: message.content.attachments,
          date: message.content.created_at,
          read_by: message.group.read_by,
          group_id: message.content.group_id ?? message.group.id,
          reply: message.content.reply ?? null,
        });
        this.scrollToBottom();
      } else {
        this.addGroupNotification(message.content.group_id);
        if (!this.isRecordingOrLiveStream()) {
          Video.chatMessageReceived({
            participants: message.group.members,
            group_id: message.content.group_id,
            message: message.content.message,
            images: message.content.images,
            attachments: message.content.attachments,
            sender_guest_id: message.content.sender,
            participant_id: this.getParticipantParticipantId(
              message.content.sender
            ),
            sender_name:
              message.content?.sender_name &&
              message.content?.sender_name !== "N/A"
                ? message.content?.sender_name
                : this.getParticipantDisplayName(message.content.sender),
            group_name: this.getGroupName(message.group.members),
            groupNotifications: this.groupNotifications.find(
              (group) => group.group_id == message.content.group_id
            ).notifications,
          });
        }
      }
      renderChatsList();
      this.downloadMessageButton();
    }

    isMyMessage(message) {
        // console.log("Is my Message", message);
        if(message?.external){
            return this.provider.isMyMessage(message);
        }
        if (
            message.user_id == this.myUniqueId ||
            (USER_ID > 0 && message.sender_user_id == USER_ID)
        )
            return true;
    }

    renderAttachment(attachment) {
        console.log("Rendering Attachment", attachment);
        if(attachment.contentType === "reference"){
            //build a link reference
            $(`#${attachment.id}`).html(`
                <a href="${attachment.contentUrl}" class="attachment-reference" target="_blank" nofollow title="${attachment.contentUrl}">📄 ${attachment.name}</a>
                `)
        }else if(attachment.contentType === "messageReference"){
            const content = JSON.parse(attachment.content);
            const replyMessageSender = $("<span/>", {
                class: "reply-message-sender",
                html: content.messageSender?.user?.displayName ?? ''
            })
            const replyMessage = $("<span/>", {
                class: "reply-message",
                html: content.messagePreview ?? ''
            })
            const replyMessageContent = $("<div/>", {
                class: "reply-message-content",
                html: [
                    replyMessageSender,
                    replyMessage
                ]
            }).on('click',()=>{
                console.log("Message Reply click",content)
                this.onMessageReferenceClick(content.messageId)
            })
            $(`#${attachment.id}`).html(replyMessageContent)
        }
    }

    onMessageReferenceClick(messageId) {
        const message = this.messages[this.selectedChatId].find(m=>m.id==messageId);
        if(message){
            //message exists in the loaded messages. scroll
            const messageElement = document.getElementById(`message-${messageId}`);

            if (messageElement) {
                messageElement.scrollIntoView({
                    behavior: 'smooth', // smooth scrolling
                    block: "nearest"     // scroll to the center of the container
                });
                setTimeout(() => {
                    messageElement.classList.add('target-highlight');
                    setTimeout(() => {
                        messageElement.classList.remove('target-highlight');
                    }, CHAT_MESSAGE_HIGHLIGHT_DURATION);
                },400);
            }
        }else{
            //messages it is not loaded we need to load older messages
        }
    }


    // <span class="read-by"><i class="fas fa-eye"></i> ${read_by.map(reader => this.getParticipantDisplayName(reader)).join(', ') }</span>
    // sender, message_content, message_images, message_time, read_by, failedToSend=false
    async addMessageToHTML(props,scrollBottom=true,prepend=false) {
    //   console.log("adding message to html",props);
      let chat_container = document.querySelector("#chat-message-container");
      const scrollOffset = chat_container.scrollHeight - chat_container.scrollTop;

      // Never let a non-string body leak into the DOM as "[object Object]".
      if (props.message !== null && props.message !== undefined && typeof props.message !== "string") {
        props.message = (typeof props.message === "object"
          ? (props.message.message ?? props.message.text ?? props.message.body ?? "")
          : String(props.message));
      }

      let normal_text = $("<span />", {
        html: props.message,
      });
      if (normal_text.find(".emoji-icon").length < 4)
        normal_text.find(".emoji-icon").text("");
      normal_text = normal_text.text();

      if (!props.message && !props?.images?.length && !props?.videos?.length && !props?.attachments?.length) return;

      // Remove the "No messages to show." placeholder before rendering a real message
      $("#messages-list-container .no-messages").closest("div").remove();

      props.userName = sanitizeHtml(
        props.sender_name !== "N/A"
          ? props.sender_name
          : this.getParticipantDisplayName(props.user_id),
        this.sanitizeNoOptions
      );

      const myMessage = this.isMyMessage(props);
      props.message = this.replaceURLWithHTMLLinks(
        props.message,
        myMessage ? "text-white" : ""
      );


      const sanitizedMessage = sanitizeHtml(props.message,{
        allowedTags: sanitizeHtml.defaults.allowedTags.concat([ 'img','video','at','attachment' ]),
        allowedAttributes: false,
        exclusiveFilter: function(frame) {
          const text = frame.text.trim();
          return frame.tag === 'a' && (text === 'Sent via Kino Co-Working Space. Click to Enter' || text === 'Sent via Kino Workspace. Click to Enter');
        }
      })

        const parser = new DOMParser();
        const messageHtml = parser.parseFromString(sanitizedMessage, 'text/html');

        const htmlImages = messageHtml.querySelectorAll("img");
        htmlImages.forEach(async (imgTag)=>{
            const MediaId = uuidv4();
            imgTag.loading = "lazy";
            imgTag.classList.add('inline-image');
            imgTag.id = MediaId;

            const fancyBoxWrapper = document.createElement('a');
            fancyBoxWrapper.setAttribute('data-fancybox', props.group_id);
            fancyBoxWrapper.id = 'a-'+MediaId;
            fancyBoxWrapper.href = imgTag.src;
            fancyBoxWrapper.classList.add('fancybox-wrapper');

            imgTag.parentNode.replaceChild(fancyBoxWrapper, imgTag);
            fancyBoxWrapper.appendChild(imgTag);

            if (props?.external) {
                this.provider.getMediaUrl(imgTag.src).then(publicUrl => {
                    try {
                        document.getElementById(MediaId).src = publicUrl;
                        document.getElementById('a-'+MediaId).href = publicUrl;
                    } catch (error) {
                        setTimeout(() => {
                            document.getElementById(MediaId).src = publicUrl;
                            document.getElementById('a-'+MediaId).href = publicUrl;
                        }, 200);
                    }

                    if (scrollBottom) {
                        this.scrollToBottom();
                    }
                });
            }
        })

        const htmlVideos = messageHtml.querySelectorAll("video");

        htmlVideos.forEach(async (videoTag)=>{
            const MediaId = uuidv4();
            videoTag.classList.add('inline-image');
            videoTag.id = MediaId;
            const fancyBoxWrapper = document.createElement('a');
            fancyBoxWrapper.setAttribute('data-fancybox', props.group_id);
            fancyBoxWrapper.id = 'a-'+MediaId;
            fancyBoxWrapper.setAttribute('data-type','html5video');

            videoTag.parentNode.replaceChild(fancyBoxWrapper, videoTag);
            fancyBoxWrapper.appendChild(videoTag);
            if (props?.external) {
                this.provider.getMediaUrl(videoTag.src).then(async(url) => {

                    if (url instanceof ReadableStream) {
                        const blob = await readableStreamToBlob(url);
                        document.getElementById(MediaId).src = URL.createObjectURL(blob);
                        document.getElementById('a-'+MediaId).setAttribute('data-src',URL.createObjectURL(blob));
                    } else {
                        document.getElementById(MediaId).src = url;
                        document.getElementById('a-'+MediaId).setAttribute('data-src',url);
                    }

                    if (scrollBottom) {
                        this.scrollToBottom();
                    }
                });
            }
        })

      const safeMessageHtml = messageHtml.body.innerHTML;
      const $container = $("#messages-list-container");
      const prevMeta = prepend ? getNextMessageMeta($container) : getPreviousMessageMeta($container);
      maybeInsertDateSeparator($container, props.date, prepend);

      const { grouped, seen } = computeGroupedAndSeen({
        prevMeta,
        props,
        myMessage,
        readBy: props.read_by,
        myUniqueId: this.myUniqueId,
        myUserId: USER_ID,
        isLastMine: props.isLastMine ?? (myMessage && !prepend),
      });

      const html = buildMessageBlockHtml({
        props: { ...props, userName: props.userName, importance: props.importance },
        myMessage,
        safeMessage: safeMessageHtml,
        normalTextLength: normal_text.length,
        attachmentsHtml: this.renderMessageAttachments(props.attachments, props.group_id, {
          remoteLoading: !myMessage,
        }),
        imagesHtml: '',
        grouped,
        seen,
        showReplyButton: true,
      });

      if (prepend) {
        $container.prepend(html);
      } else {
        if (props.isLastMine && myMessage) {
          $container.find('.message.text-right .message-time').each(function () {
            $(this).text($(this).text().replace('  ✓ Seen', ''));
          });
        }
        $container.append(html);
      }

          if (!myMessage && props.attachments?.length && props.id) {
            bindIncomingImageAttachmentLoading(document.getElementById(`message-${props.id}`));
          }
          if(props.attachments){
            props.attachments.forEach(attachment => {
                this.renderAttachment(attachment);
            })
          }
          if(scrollBottom){
            this.scrollToBottom();
          }else{
            chat_container.scrollTop = chat_container.scrollHeight - scrollOffset;
          }
      // end card 120
    }


    startMessageReply(message,messageText){
        this.isMessageReply=message;
        const messagePreview = messageText.trim().length === 0 ? this.formatLastMessage(message.message,100) : messageText.slice(0,100);
        const replyMessageContent = $('<div/>',{
            class:"reply-message-content",
            html: `<span class="reply-message-sender">${message.sender_name}</span>
                    <span class="reply-message">${messagePreview}</span>`
        })

        const cancelReplyButton = $('<span/>',{
            class:'cancel-reply-button',
            html: `<svg aria-hidden="true" width="16" height="16" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                 <path fill="white" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19
                 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34
                 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12
                 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12
                 3.12-8.19 0-11.31L193.94 256z">
                 </path>
             </svg>`
        }).on('click',this.clearMessageReply.bind(this))

        const $replyContainer = $('#reply-to-container');
        $replyContainer.empty().append(replyMessageContent, cancelReplyButton).show();
        this.messageEditor.focus()
    }

    clearMessageReply(){
        this.isMessageReply=null;
        $('#reply-to-container').empty().hide();
    }


    formatDate(dateString) {
        return formatBubbleTime(dateString);
    }

    retrieveReadMessage(message) {}

    sendReadMessage(participants) {
      let message = {
        message: "read_by",
        participants: participants.map((pp) => pp),
        by: this.myUniqueId,
      };
      room.broadcastEndpointMessage(message);
    }

    endpointMessageReceived(user, message) {
      console.log("Endpoint message received", message);
      if (!permissions.hasChat()) {
        return;
      }
      if (message.type) return;

      // received a new message
      if (message.chat_message) return this.retrieveMessage(message);

      // someone has read the message
      if (message.read_by) return this.retrieveReadMessage(message);

      if (message.message_type && message.message_type == "typing_message")
        return this.receiveTypingMessage(message);
    }

    // clicking a chat
    async selectGroupChat(e) {
      e.preventDefault();
      if ($("#chat-nav-tab").hasClass("active")) {
        // card 473
        this.closeChatList();
        // end card 473
        $("#message-text-field").focus();
        let group_id = $(e.currentTarget).data("group")
          ? $(e.currentTarget).data("group")
          : null;

        if (group_id) {
          this.selectGroupChatById(group_id);
        } else if ($(e.currentTarget).data("participant")) {
          this.clearSelectedGroupChatHTML();
          this.selectedParticipantsToMessage = [];
          this.addToSelectedParticipantToMessageById(
            $(e.currentTarget).data("participant")
          );
          this.selectedChatId = false;
          this.clearChat();
          if (!this.participantHasChat($(e.currentTarget).data("participant"))) {
            setTimeout(() => {
              this.addChatNotAvailable();
            }, 500);
          }
        }

        // card 359
        this.downloadMessageButton();
        // end card 359
      }
    }

    async setChatselected(chat) {

        let group_id = chat?.group;

        if (group_id) {
            this.selectGroupChatById(group_id);
        } else if (chat.pId) {
            this.activateComposerConversation(pendingConversation([chat.pId]));
            this.clearSelectedGroupChatHTML();
            this.selectedParticipantsToMessage = [];
            this.addToSelectedParticipantToMessageById(chat.pId);
            this.selectedChatId = false;
            this.clearChat(false);
            if (!this.participantHasChat(chat.pId)) {
                setTimeout(() => {
                    this.addChatNotAvailable();
                }, 500);
            }
        }
        $("#message-text-field").trigger('focus');
        // Fancybox is bound once globally on [data-fancybox] in events(); no per-chat rebind needed.

    }

    addChatNotAvailable() {
      $("#messages-list-container").append(`
              <div class="chat-na-container">
                  <div class="chat-na-box">
                      <p>The chat is disabled for this person.</p>
                  </div>
              </div>
          `);
    }

    selectGroupChatById(group_id, useHtml = true) {
      if (group_id) {
        setSelectedChatActive(group_id);
        this.selectedParticipantsToMessage = [];
        if (useHtml) this.clearSelectedGroupChatHTML();
        const group = this.groups.find((group) => group.id == group_id);
        console.log("Group to be selected", group);
        if (!group) return;
        this.activateComposerConversation(groupConversation(group.id));

        if (group.id == group_id) {
          this.selectedChatId = group.id;
          this.lastSelectedChatId = this.selectedChatId;
          group.members.forEach((pp) => {
            // prevent from adding yourself in this selected group chat
            if (
              pp.guest_id != this.myUniqueId &&
              (USER_ID == 0 || pp.user_id != USER_ID)
            ) {
              this.selectedParticipantsToMessage.push(pp.guest_id);
              // if(useHtml) this.addToSelectedParticipantToMessageHTML(pp.guest_id, pp.displayName);
              if (useHtml)
                this.addToSelectedParticipantToMessageHTML(
                  pp.guest_id,
                  pp.displayName
                );
            }
          });
        }

        if (!this.selectedParticipantsToMessage.length) {
          this.makePublicChatVisible();
        }
        this.readMessagesbyGroupId(group_id);
        this.showMessagesByGroupId(group_id);

        this.scrollToBottom();
      }
      this.downloadMessageButton();
    }

    async showMessagesByGroupId(group_id) {
      const group = this.groups.find((group) => group.id == group_id);
      if (!group) return;
      this.clearChat();
      if(group?.isExternal){
        const cachedMessages = this.provider.getCachedMessages(group.id);
        if (cachedMessages && cachedMessages.length) {
            this.messages[group_id] = cachedMessages;
            if (cachedMessages.length < this.messagesPerPage) {
                this.hasMoreMessages = false;
            }
            await this.renderMessages(group_id, group);
        }

        this.provider.getMessages(group.id).then(async (freshMessages) => {
            if (freshMessages.length < this.messagesPerPage) {
                this.hasMoreMessages = false;
            }
            this.messages[group_id] = freshMessages;
            if (group_id === this.selectedChatId) {
                this.clearChat();
                await this.renderMessages(group_id, group);
            }
        }).catch(error => {
            console.error("Failed to refresh messages from API", error);
        });
        return;
      }

      if (!this.messages[group_id]) {
        return;
      }
      await this.renderMessages(group_id, group);
    }

    async renderMessages(group_id, group) {
      if (!this.messages[group_id]) return;
      const messages = this.messages[group_id];
      let lastMineIndex = -1;
      messages.forEach((m, i) => {
        if (this.isMyMessage({ user_id: m.sender, sender_user_id: m.sender_user_id })) {
          lastMineIndex = i;
        }
      });
      for (let index = 0; index < messages.length; index++) {
        const message = messages[index];
        await this.addMessageToHTML({
          id: message.id,
          user_id: message.sender,
          sender_name: message.sender_name,
          sender_user_id: message.sender_user_id,
          message: message.message,
          images: message?.images ?? [],
          videos: message?.videos ?? [],
          date: message.created_at,
          read_by: group.read_by,
          group_id: group_id,
          external: message?.external,
          attachments: message?.attachments ?? [],
          importance: message?.importance ?? 'normal',
          reply: message?.reply ?? null,
          isLastMine: index === lastMineIndex,
        }, true, false);
      }
    }

    sendTypingMessage(e) {
      if (this.sendingTypingMessageToUser) return;
      this.sendingTypingMessageToUser = true;
      setTimeout(() => {
        this.sendingTypingMessageToUser = false;
      }, TYPING_INDICATOR_TIMEOUT);
      room.broadcastEndpointMessage({
        message_type: "typing_message",
        chat_id: this.selectedChatId,
        sender: this.myUniqueId,
      });
    }

    receiveTypingMessage(message) {
      // console.log("Received typing message", message);
      // console.log("My chat id",this.selectedChatId);
      this.mainChat.sendMessage({
        eventName: "typingStarted",
        ...message,
      });
      if (message.chat_id == this.selectedChatId && message.chat_id) {
        if (this.typingTimout) clearTimeout(this.typingTimout);
        $("#writing-message").html(
          `<i class="fas fa-pen"></i> <strong>${this.getParticipantDisplayName(
            message.sender
          )}</strong> is typing...`
        );
      }
      this.typingTimout = setTimeout(() => {
        $("#writing-message").html("");
      }, TYPING_DISPLAY_DURATION);
    }

    /**
     *      HTML MANIPULATOR FOR CLASSES
     *      HTML SETTERS
     *
     *
     */
    closeChatSelection(evt) {
      if (!$(evt.target).closest(".select-chat-list").length) {
        this.closeAddParticipantList();
        this.closeChatList();
      }

      // card 291
      if (
        !$(evt.target).closest("#myConvoPanel").length &&
        $("#myConvoPanel").hasClass("open") &&
        !$(evt.target).hasClass("download-js-link") &&
        !evt.target.closest(".chatBubbleContainer") &&
        evt?.target?.tagName !== "HTML" &&
        evt?.target?.tagName !== "INPUT" &&
        !evt.target.closest(".menu-content")
      ) {
        // card id 829
        console.trace("Called CloseChatSelection", evt.target);
        CONV_STORAGE.closePanel();
        // end card id 829
        this.closeAddParticipantList();
        this.closeChatList();
        this.lastSelectedChatId = this.selectedChatId;
        this.selectedChatId = false;
      }
      // end card 291
    }

    closeAddParticipantList() {
      if (
        $("#chat-content-container").find(".select-user-list").hasClass("active")
      ) {
        $("#chat-content-container")
          .find(".select-user-list")
          .removeClass("active");
      }
    }
    openAddParticipantList() {
      if (
        !$("#chat-content-container").find(".select-user-list").hasClass("active")
      ) {
        $("#chat-content-container").find(".select-user-list").addClass("active");
      }
    }

    getUserButton(name) {
      return `<div class="user-icon" title="${name}" data-toggle="tooltip" data-placement="top">${this.profileImgUser}</div>`;
    }

    // appending someone in to chat with
    addParticpiantInGroupChatHTML(pId, displayName) {
      // card 120
      $("#add-chat-participant-list").append(`
              <li class="list-item">
                  <a class="participant-item" data-id="${pId}">
                      <div class="profile-img">
                          ${this.getUserButton(
                            sanitizeHtml(
                              displayName.replace(/^\s+|\s+$/g, ""),
                              this.sanitizeNoOptions
                            )
                          )}
                      </div>
                      <div class="profile-desc">
                          <div class="full-name">
                              <span>${sanitizeHtml(
                                displayName.replace(/^\s+|\s+$/g, ""),
                                this.sanitizeNoOptions
                              )}</span>
                          </div>
                      </div>
                  </a>
              </li>
          `);
      // end card 120
    }

    // card 120
    addToSelectedParticipantToMessageHTML(pId, displayName) {
      $(
        "#chat-content-container .chat-list-participant-group li.pub-chat"
      ).addClass("d-none");
      $(
        "#chat-content-container .messages .chat-list-participant-group li:last"
      ).before(
        `<li data-id="${pId}" class="user-list-children">
                  <div class="chat-list-participant-item">
                      ${this.getUserButton(
                        sanitizeHtml(
                          displayName.replace(/^\s+|\s+$/g, ""),
                          this.sanitizeNoOptions
                        )
                      )}
                      <div class="user-name">
                          <span>${sanitizeHtml(
                            displayName.replace(/^\s+|\s+$/g, ""),
                            this.sanitizeNoOptions
                          )}</span>
                      </div> <i class="fas fa-times" title="Remove Participant" data-toggle="tooltip" data-placement="top"></i>
                  </div>
              </li>`
      );
      this.clearChat();
      $("#search-new-particpant").val("");
      let userListLength = $(
        `.chat-list-participants .chat-list-participant-group li[data-id]:not(.d-none)`
      ).length;
      if (userListLength > 5) {
        // $(`.user-list-children .chat-list-participant-item .user-name:nth-child(${userListLength - 5})`).addClass('d-none')
        $(
          `.chat-list-participants .chat-list-participant-group li[data-id]:not(.d-none)`
        )
          .eq(0)
          .addClass("d-none");
      }
    }

    // end card 120

    clearChat(hasMessages=true) {
    //   console.trace("clearing chat");
        this.loadingMoreText.html("")
        this.messagesListAtBottom=true;
        this.hasMoreMessages=true;
      $("#messages-list-container").empty();
        if(!hasMessages) $("#messages-list-container").html(`<div class="d-flex justify-content-center text-center text-white-50 w-100"><p class="no-messages">No messages to show.</p></div>`);
    }

    clearSelectedGroupChatHTML() {
      $("#chat-content-container .messages .chat-list-participant-group")
        .children()
        .each((index, el) => {
          if (
            !$(el).find("input").length &&
            !$(el).find("div.public-chat").length
          ) {
            $(el).remove();
          }
        });
    }

    makePublicChatVisible() {
      $(
        "#chat-content-container .chat-list-participant-group li.pub-chat"
      ).removeClass("d-none");
    }

    scrollToBottom() {
      let chat_container = document.querySelector("#chat-message-container");
      chat_container.scrollTop = chat_container.scrollHeight;
    }

    makeChatTabActive() {
      $("#conversations-tab-nav").removeClass("active");
      $("#conversations-tab-nav").attr("aria-selected", false);
      $("#conversations-tab").removeClass("active");
      $("#conversations-tab").removeClass("show");
      stopMediaPlayers($("#conversations-tab")); //card 599

      $("#chat-nav-tab").addClass("active");
      $("#chat-nav-tab").attr("aria-selected", true);
      $("#chatting-tab").addClass("active");
      $("#chatting-tab").addClass("show");
    }

    replaceURLWithHTMLLinks(text, color) {
        const httpsPattern = /(\b(https?|ftp|file|http):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
        const wwwPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gi;
        const emailPattern = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gi;

        const parser = new DOMParser();
        const doc = parser.parseFromString(text ?? '', 'text/html');

        const linkify = (value) =>
            value
                .replace(
                    httpsPattern,
                    "<a class='kino-links " + color + "' target='_blank' href='$1'>$1</a>"
                )
                .replace(
                    wwwPattern,
                    "<a class='kino-links " + color + "' target='_blank' href='https://$2'>$2</a>"
                )
                .replace(
                    emailPattern,
                    "<a class='kino-links " + color + "' href='mailto:$1' target='_blank'>$1</a>"
                );

        // Walk text nodes only, never re-linkifying inside existing anchors/media.
        // Matched text is parsed back into real DOM nodes (not assigned to
        // nodeValue) so links render as HTML instead of being escaped to text.
        const walk = (node) => {
            if (node.nodeType === Node.TEXT_NODE) {
                const replaced = linkify(node.nodeValue);
                if (replaced !== node.nodeValue) {
                    const wrapper = document.createElement('span');
                    wrapper.innerHTML = replaced;
                    node.replaceWith(...Array.from(wrapper.childNodes));
                }
            } else if (node.nodeType === Node.ELEMENT_NODE && !['A', 'IMG', 'VIDEO', 'CODE'].includes(node.tagName)) {
                Array.from(node.childNodes).forEach(walk);
            }
        };

        Array.from(doc.body.childNodes).forEach(walk);

        return doc.body.innerHTML;
      }

    openChatInPopUp() {
      console.log("Main chat open popup", this.mainChat);
      if (permissions.hasChat()) {
        this.mainChat.openChatPopup();
      }
    }

    // chat popup api
    registerChatApi() {
      let chat = this;
      this.mainChat.listenMain("getChatsList", chat.getChatsListApi.bind(chat));
      this.mainChat.listenMain("getGroupId", chat.getGroupIdApi.bind(chat));
      this.mainChat.listenMain(
        "getGroupById",
        chat.getGroupChatByIdApi.bind(chat)
      );
      this.mainChat.listenMain(
        "getGroupMessages",
        chat.getGroupMessagesApi.bind(chat)
      );
      this.mainChat.listenMain(
        "typingMessage",
        chat.sendTypingMessageApi.bind(chat)
      );
      this.mainChat.listenMain(
        "addMessageToQueue",
        chat.addMessageToQueue.bind(chat)
      );
      this.mainChat.listenMain(
        "performMessageSend",
        chat.performMessageSendApi.bind(chat)
      );
      this.mainChat.listenMain(
        "countGroupMessages",
        chat.countGroupMessagesApi.bind(chat)
      );
      this.mainChat.listenMain(
        "downloadMessages",
        chat.downloadMessagesApi.bind(chat)
      );
      this.mainChat.listenMain(
        "readGroupMessages",
        chat.readMessagesByGroupIdAPI.bind(chat)
      );
      this.mainChat.listenMain(
        "chat-popoup-close",
        chat.onChatPopupClose.bind(chat)
      );
      this.mainChat.listenMain(
        "getChatsListArray",
        chat.getChatsListArrayApi.bind(chat)
      );
      this.mainChat.listenMain(
        "isParticipantOnline",
        chat.isParticipantOnlineApi.bind(chat)
      );
      this.mainChat.listenMain(
        "createGroupChatFromMenu",
        chat.createGroupChatFromMenuApi.bind(chat)
      );
      this.mainChat.listenMain(
        "addMembersFromMenu",
        chat.addMembersFromMenuApi.bind(chat)
      );
      this.mainChat.listenMain(
        "encryptChatMessage",
        chat.encryptChatMessageApi.bind(chat)
      );
      this.mainChat.listenMain(
        "broadcastAttachmentMessage",
        chat.broadcastAttachmentMessageApi.bind(chat)
      );
    }

    // Popup uploads attachment files itself (File objects cannot cross postMessage),
    // but text encryption stays centralized here. The popup asks the opener to
    // encrypt the outgoing text for a group, then posts the multipart request.
    async encryptChatMessageApi(msg) {
      let encrypted = msg.message ?? "";
      try {
        const encryption_key = await this.getChatEncryptionKey(msg.group_id);
        if (encryption_key) {
          encrypted = this.encryptString(encryption_key, encrypted);
        }
      } catch (error) {
        console.error("[Kino Error] [encryptChatMessageApi]", error);
      }
      this.mainChat.sendMessage({
        msgId: msg.msgId,
        encrypted: encrypted,
      });
    }

    // After the popup persisted an attachment message, the opener stores it
    // locally and broadcasts it to the rest of the Kino, reusing the standard
    // "message_received_from_kino_user" envelope.
    broadcastAttachmentMessageApi(msg) {
      try {
        const group_id = msg.group_id;
        const saved = msg.message;
        if (!group_id || !saved) return;
        this.storeGroupMessage(group_id, {
          ...saved,
          message: msg.encryptedMessage ?? saved.message,
        });
        room.broadcastEndpointMessage({
          chat_message: "message_received_from_kino_user",
          content: {
            ...saved,
            message: msg.encryptedMessage ?? saved.message,
            images: [],
            attachments: saved.attachments ?? [],
          },
          group: this.getGroupChatById(group_id),
        });
        renderChatsList();
      } catch (error) {
        console.error("[Kino Error] [broadcastAttachmentMessageApi]", error);
      }
    }

    onChatPopupClose(msg) {
      this.lastSelectedChatId = msg.selectedChatId;
    }
    readMessagesByGroupIdAPI(msg) {
      this.readMessagesbyGroupId(msg.group_id);
    }

    onParticipantsChanged() {
      if (this.mainChat.chatWindow) {
        let participants = room.getParticipants().map((p) => {
          return {
            guest_id: p.getProperty("guest_id"),
            _displayName: p.getDisplayName(),
            pid: p.getId(),
          };
        });
        this.mainChat.sendMessage({
          eventName: "participantsChanged",
          participants,
        });
      }
    }

    sendGroupIdChanged(group_id, conversation_key = null) {
      this.mainChat.sendMessage({
        eventName: "selectedGroupChanged",
        group_id: group_id,
        conversation_key,
      });
    }
    downloadMessagesApi(msg) {
      this.selectedChatId = msg.group_id;
      this.downloadMessages();
    }

    getChatsListArrayApi(msg){
        console.log("Get chats list array", msg);
        this.mainChat.sendMessage({
            msgId: msg.msgId,
            chats: this.getChatsListArray().map(c=>({
                ...c,
                lastMessageTime: c.lastMessageTime.toDate()
            })),
          });
    }

    countGroupMessagesApi(msg) {
      let messagesCount = 0;
      let messages = this.messages[msg.group_id];
      messagesCount = messages?.length || 0;
      if (msg.msgId) {
        this.mainChat.sendMessage({
          msgId: msg.msgId,
          messages: messagesCount,
        });
      }
    }

    performMessageSendApi() {
      this.performMessageSend();
    }

    addMessageToQueue(msg) {
      this.messageQueue.push({ ...msg.message, date: moment() });
    }

    sendTypingMessageApi(msg) {
      try {
        room.broadcastEndpointMessage({
          message_type: "typing_message",
          chat_id: msg.selectedChatId,
          sender: this.myUniqueId,
        });
      } catch (error) { console.error("[Kino Error] [chat]", error); }
    }

    getGroupIdApi(msg) {
      let _participants = msg._participants;
      let groupId = false;
      _participants.push(this.myUniqueId);
      let groups = this.groups.filter((group) => {
        if (_participants.length == 1 && group.members.length == 0) return true; // geting public chat
        if (
          _participants.length == group.members.length &&
          group.members.every(
            (pp) =>
              _participants.includes(pp["guest_id"]) ||
              (USER_ID > 0 && pp["user_id"] == USER_ID)
          )
        )
          return true;
      });
      if (groups.length) groupId = groups[0].id;
      if (msg.msgId) {
        this.mainChat.sendMessage({
          msgId: msg.msgId,
          group_id: groupId,
        });
      }
    }
    getGroupMessagesApi(msg) {
      let messages = this.messages[msg.group_id];
      if (msg.msgId) {
        this.mainChat.sendMessage({
          msgId: msg.msgId,
          messages: messages,
        });
      }
    }
    getGroupChatByIdApi(msg) {
      let group_id = msg.group_id;
      let group = this.groups.find((group) => group.id == group_id);
      if (msg.msgId) {
        this.mainChat.sendMessage({
          msgId: msg.msgId,
          group: {...group,lastMessageTime: group.lastMessageTime.toDate()},
        });
      }
    }

    getChatsListApi(msg) {
      let participants = this.getChatsListArray();

      this.groupUniqueParticipants().forEach((el) => {
        participants.push({
          pId: el,
          group: null,
          name: this.getParticipantDisplayName(el),
          isChat: false,
        });
      });

      // perform search
      let found_items = participants.filter(
        (pp) =>
          pp.name
            .toLowerCase()
            .search($("#search-new-particpant").val().toLowerCase()) > -1
      );
      if (msg.msgId) {
        this.mainChat.sendMessage({
          msgId: msg.msgId,
          items: found_items,
        });
      }
    }

    isParticipantOnlineApi(msg) {
        const pid = msg.pid;
        this.mainChat.sendMessage({
            msgId: msg.msgId,
            online: this.isParticipantOnline(pid),
        });
    }

    createGroupChatFromMenuApi(msg) {
        const pids = msg.participants;
        createGroupChatFromMenu(pids).then((newChat) => {
            this.mainChat.sendMessage({
                msgId: msg.msgId,
                newChat: newChat,
            });
        });
    }

    addMembersFromMenuApi(msg){
        const members = msg.members;
        addMembersFromMenu(msg.group_id,members).then((data) => {
            this.mainChat.sendMessage({
                msgId: msg.msgId,
                newMembers: data,
            });
        });
    }

    async messageListTopReached(){
        if(this.messagesListAtBottom){return}
        console.log("Messages top reached")
        if(!this.hasMoreMessages){
            console.log("No more messages")
            this.loadingMoreText.html("No older messages.")
            return
        }
        try {
            const group = this.groups.find((group) => group.id == this.selectedChatId);
            if (!group) return;
            this.loadingMoreText.html("Loading older messages...")
            let olderMessages = []
            if(group?.isExternal){
                olderMessages = await this.provider.loadOlderMessages(group.id);
                if(!olderMessages || !olderMessages?.length){
                    this.loadingMoreText.html("No older messages.")
                    throw new Error("No Messages")
                }
                if(olderMessages.length < this.messagesPerPage){
                    this.loadingMoreText.html("No older messages.")
                    this.hasMoreMessages=false;
                }
                // console.log("Group Messages",olderMessages)
                const currentMessages = this.messages[group.id];
                this.messages[group.id] = [...olderMessages,...currentMessages];
            }
            const reversed = olderMessages.reverse();
            this.loadingMoreText.html("")
            for (const message of reversed) {
                // console.log("Rendering Message", message);
                await this.addMessageToHTML({
                id: message.id,
                user_id: message.sender,
                sender_name: message.sender_name,
                sender_user_id: message.sender_user_id,
                message: message.message,
                images: message?.images ?? [],
                videos: message?.videos ?? [],
                date: message.created_at,
                read_by: group.read_by,
                group_id: group.id,
                external: message?.external,
                attachments: message?.attachments ?? [],
                importance: message?.importance ?? 'normal'
                },false,true);
            }
        } catch (error) {
            console.error("Load older messages error",error)
        }
    }

    messageListBottomReached() {
        console.log("Messages bottom reached")
        this.messagesListAtBottom=true
    }
  }
